(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6509],{

/***/ 50814:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer-career-report-2025",
      function () {
        return __webpack_require__(41245);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ developer_career_report_2025; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Button.js
var Button = __webpack_require__(15659);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/ShareModal/index.ts + 1 modules
var ShareModal = __webpack_require__(9011);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/methodologyAnchor/MethodologyAnchor.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  color: inherit;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAnchor = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
    componentId: "sc-88ddec48-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* color */.$_)("midnight_300"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/methodologyAnchor/MethodologyAnchor.tsx





var MethodologyAnchor = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAnchor, {
        to: "methodology",
        href: "#methodology",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                icon: free_solid_svg_icons/* faInfoCircle */.sqG
            }),
            t("mantechcar25.methodology-anchor")
        ]
    });
};
/* harmony default export */ var methodologyAnchor_MethodologyAnchor = (MethodologyAnchor);

// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/sectionChart/SectionChart.styled.tsx

function SectionChart_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  background-color: transparent;\n  border: none;\n  appearance: none;\n  padding: 0;\n  cursor: pointer;\n  font-size: ",
        ";\n  display: none;\n  width: calc(",
        " + ",
        ");\n  margin-left: calc(-",
        " - ",
        ");\n  padding-right: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SectionChart_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  text-align: left;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  ",
        " {\n    > span {\n      display: flex;\n      align-items: center;\n    }\n    &:hover ",
        " {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  margin-top: 0;\n\n  &.isTop {\n    margin-top: -",
        ";\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var ShareTitle = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-497c75f1-0"
})(SectionChart_styled_templateObject(), (0,theme/* color */.$_)("midnight_300"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_400"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-497c75f1-1"
})(_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading2 */.XJ, ShareTitle);
var StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-497c75f1-2"
})(_templateObject2(), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"));
var StyledActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-497c75f1-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/sectionChart/SectionChart.tsx
















var SectionChart = function(param) {
    var title = param.title, children = param.children, desc = param.desc, descExtra = param.descExtra, shareId = param.shareId, shareMessage = param.shareMessage, emailMessage = param.emailMessage, emailSubject = param.emailSubject;
    var locale = (0,router.useRouter)().locale;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var ref = (0,react.useState)(false), isShareModalOpened = ref[0], setIsShareModalOpened = ref[1];
    var linkRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), copied = ref1[0], setCopied = ref1[1];
    var url;
    if (true) {
        url = "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar25 */.uu.mantechcar25, locale), "#").concat(shareId);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        id: shareId,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                as: "h3",
                editorial: true,
                alignLeft: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        shareId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTitle, {
                                    ref: linkRef,
                                    onClick: function() {
                                        navigator.clipboard.writeText(url);
                                        setCopied(true);
                                        setTimeout(function() {
                                            setCopied(false);
                                        }, 2000);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: pro_solid_svg_icons/* faLink */.nNP
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                    content: t("mantechcar25.copied"),
                                    direction: "up",
                                    distance: 65,
                                    isOpen: copied
                                })
                            ]
                        }),
                        title
                    ]
                })
            }),
            desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                className: "isTop",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "developer-career-report-2025",
                    i18nKey: desc
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledActions, {
                children: [
                    shareId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                        variant: "secondary",
                        type: "button",
                        onClick: function() {
                            service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("mandecar-compartir");
                            setIsShareModalOpened(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: pro_light_svg_icons/* faShareSquare */.tFX
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("mantechcar25.footer-share")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(methodologyAnchor_MethodologyAnchor, {})
                ]
            }),
            descExtra && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDesc, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    ns: "developer-career-report-2025",
                    i18nKey: descExtra
                })
            }),
            emailSubject && emailMessage && shareMessage && isShareModalOpened && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal["default"], {
                isOpened: isShareModalOpened,
                close: function() {
                    return setIsShareModalOpened(false);
                },
                url: "".concat(window.location.origin, "/").concat(locale).concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.mantechcar25 */.uu.mantechcar25, locale), "#").concat(shareId),
                emailSubject: emailSubject,
                twitterMessage: shareMessage,
                telegramMessage: shareMessage,
                whatsappMessage: shareMessage,
                emailMessage: emailMessage
            })
        ]
    });
};
/* harmony default export */ var sectionChart_SectionChart = (SectionChart);

// EXTERNAL MODULE: ./components/shared/RadioButton.tsx
var RadioButton = __webpack_require__(73273);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/switcher/Switcher.styled.tsx

function Switcher_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin: 0 0 ",
        ";\n  border: 0;\n  padding: 0;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: center;\n    gap: ",
        ";\n  }\n\n  legend {\n    font-weight: ",
        ";\n    float: left;\n    padding: 0;\n  }\n"
    ]);
    Switcher_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Switcher_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  &.is-active {\n    display: block;\n  }\n"
    ]);
    Switcher_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwitcher = styled_components_browser_esm/* default.fieldset.withConfig */.ZP.fieldset.withConfig({
    componentId: "sc-f1ffb830-0"
})(Switcher_styled_templateObject(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("black"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f1ffb830-1"
})(Switcher_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/switcher/Switcher.tsx




var Switcher = function(param) {
    var tabsName = param.tabsName, tabs = param.tabs, label = param.label;
    var defaultTabChecked = tabs.findIndex(function(tab) {
        return tab.defaultChecked === true;
    });
    var defaultTabCheckedPosition = defaultTabChecked >= 0 ? defaultTabChecked : 0;
    var ref = (0,react.useState)(tabs[defaultTabCheckedPosition].id), activeTab = ref[0], setActiveTab = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwitcher, {
                role: "tablist",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                        children: label
                    }),
                    tabs.map(function(tab, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                            name: tabsName,
                            id: tab.id,
                            label: tab.label,
                            "aria-controls": tab.id + "_content",
                            "aria-selected": activeTab === tab.id,
                            onChange: function() {
                                return setActiveTab(tab.id);
                            },
                            checked: activeTab === tab.id
                        }, index);
                    })
                ]
            }),
            tabs.map(function(tab, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                    id: tab.id + "_content",
                    role: "tabpanel",
                    "aria-labelledby": tab.id,
                    className: activeTab === tab.id ? "is-active" : "",
                    children: tab.content
                }, index);
            })
        ]
    });
};
/* harmony default export */ var switcher_Switcher = (Switcher);

;// CONCATENATED MODULE: ./data/mantechcar25/salary-by-role-and-experience.json
var salary_by_role_and_experience_namespaceObject = JSON.parse('[{"role":"Backend Developer","0-2":{"20-30k":67.45,"30-40k":14.55,"40-50k":7.61,"50-60k":4.18,"60-80k":3.8,"+80k":2.41},"2-5":{"20-30k":29.69,"30-40k":27.11,"40-50k":19.02,"50-60k":10.05,"60-80k":8.6,"+80k":5.53},"5-10":{"20-30k":9.93,"30-40k":18.54,"40-50k":26.73,"50-60k":18.31,"60-80k":16.49,"+80k":10},"10-":{"20-30k":5.47,"30-40k":13.33,"40-50k":25.9,"50-60k":22.75,"60-80k":21.52,"+80k":11.03}},{"role":"Data Analyst & BI","0-2":{"20-30k":67.68,"30-40k":18.67,"40-50k":6.79,"50-60k":2.99,"60-80k":1.7,"+80k":2.17},"2-5":{"20-30k":30.23,"30-40k":27.5,"40-50k":23.06,"50-60k":9.91,"60-80k":6.15,"+80k":3.16},"5-10":{"20-30k":14.18,"30-40k":19.97,"40-50k":25,"50-60k":19.97,"60-80k":14.33,"+80k":6.55},"10-":{"20-30k":8.21,"30-40k":15.27,"40-50k":25.76,"50-60k":19.85,"60-80k":22.9,"+80k":8.02}},{"role":"Data Engineer","0-2":{"20-30k":50.08,"30-40k":22.58,"40-50k":11.8,"50-60k":6.95,"60-80k":6.17,"+80k":2.42},"2-5":{"20-30k":17.66,"30-40k":25.11,"40-50k":24.73,"50-60k":14.99,"60-80k":11.42,"+80k":6.09},"5-10":{"20-30k":8.09,"30-40k":9.09,"40-50k":21.42,"50-60k":26.4,"60-80k":22.67,"+80k":12.33},"10-":{"20-30k":5.36,"30-40k":9,"40-50k":17.99,"50-60k":18.34,"60-80k":30.8,"+80k":18.51}},{"role":"Data Scientist","0-2":{"20-30k":51.26,"30-40k":23.88,"40-50k":12.03,"50-60k":5.84,"60-80k":4.47,"+80k":2.52},"2-5":{"20-30k":18.61,"30-40k":25.33,"40-50k":23.87,"50-60k":14.74,"60-80k":11.17,"+80k":6.28},"5-10":{"20-30k":10.24,"30-40k":12.35,"40-50k":21.23,"50-60k":22.29,"60-80k":22.74,"+80k":11.14},"10-":{"20-30k":7.08,"30-40k":10.03,"40-50k":22.42,"50-60k":18.29,"60-80k":24.78,"+80k":17.4}},{"role":"DevOps & Infrastructure & SRE","0-2":{"20-30k":46.94,"30-40k":19.14,"40-50k":12.83,"50-60k":7.97,"60-80k":8.84,"+80k":4.28},"2-5":{"20-30k":17.18,"30-40k":19.66,"40-50k":24.67,"50-60k":17.18,"60-80k":13.75,"+80k":7.56},"5-10":{"20-30k":5.88,"30-40k":10.31,"40-50k":20.79,"50-60k":20.63,"60-80k":25.79,"+80k":16.6},"10-":{"20-30k":3.83,"30-40k":7.74,"40-50k":19.06,"50-60k":20.85,"60-80k":29.53,"+80k":18.98}},{"role":"Engineering Management","0-2":{"20-30k":28.06,"30-40k":16.94,"40-50k":20,"50-60k":16.11,"60-80k":9.44,"+80k":9.44},"2-5":{"20-30k":13.62,"30-40k":9.68,"40-50k":16.34,"50-60k":17.06,"60-80k":23.94,"+80k":19.35},"5-10":{"20-30k":7.74,"30-40k":5.09,"40-50k":11.44,"50-60k":15.94,"60-80k":29.17,"+80k":30.62},"10-":{"20-30k":1.59,"30-40k":3.18,"40-50k":9.24,"50-60k":17.18,"60-80k":34.22,"+80k":34.58}},{"role":"Frontend Developer","0-2":{"20-30k":71.56,"30-40k":12.36,"40-50k":6.39,"50-60k":4.24,"60-80k":3.33,"+80k":2.12},"2-5":{"20-30k":35.59,"30-40k":27.38,"40-50k":16.83,"50-60k":8.07,"60-80k":7.22,"+80k":4.91},"5-10":{"20-30k":12.69,"30-40k":20.42,"40-50k":27.03,"50-60k":18.05,"60-80k":14.23,"+80k":7.58},"10-":{"20-30k":8.12,"30-40k":15.8,"40-50k":27.31,"50-60k":20.97,"60-80k":17.91,"+80k":9.9}},{"role":"Full-Stack Developer","0-2":{"20-30k":68.69,"30-40k":13.31,"40-50k":6.98,"50-60k":4.66,"60-80k":3.89,"+80k":2.48},"2-5":{"20-30k":31.26,"30-40k":27.99,"40-50k":18.69,"50-60k":8.86,"60-80k":8.28,"+80k":4.92},"5-10":{"20-30k":10.77,"30-40k":19.38,"40-50k":27.28,"50-60k":17.71,"60-80k":15.62,"+80k":9.24},"10-":{"20-30k":6.01,"30-40k":13.7,"40-50k":27.09,"50-60k":22.28,"60-80k":20.01,"+80k":10.92}},{"role":"Machine Learning Engineer","0-2":{"20-30k":63.39,"30-40k":23.11,"40-50k":5.93,"50-60k":3.27,"60-80k":1.23,"+80k":3.07},"2-5":{"20-30k":14.56,"30-40k":26.52,"40-50k":28.6,"50-60k":17.68,"60-80k":9.19,"+80k":3.47},"5-10":{"20-30k":5.1,"30-40k":9.55,"40-50k":20.7,"50-60k":23.57,"60-80k":27.39,"+80k":13.69},"10-":{"20-30k":5.29,"30-40k":6.88,"40-50k":14.29,"50-60k":21.69,"60-80k":30.16,"+80k":21.69}},{"role":"Mobile Developer","0-2":{"20-30k":65.11,"30-40k":14.76,"40-50k":9.15,"50-60k":4.6,"60-80k":4.07,"+80k":2.3},"2-5":{"20-30k":28.48,"30-40k":22.88,"40-50k":19.15,"50-60k":10.3,"60-80k":11.08,"+80k":8.13},"5-10":{"20-30k":11.86,"30-40k":15.13,"40-50k":22.41,"50-60k":20.82,"60-80k":18.39,"+80k":11.39},"10-":{"20-30k":3.07,"30-40k":12.48,"40-50k":24.18,"50-60k":23.22,"60-80k":22.26,"+80k":14.78}},{"role":"Product Design (UI/UX)","0-2":{"20-30k":76.11,"30-40k":13.61,"40-50k":5.2,"50-60k":1.98,"60-80k":1.24,"+80k":1.86},"2-5":{"20-30k":43,"30-40k":32.75,"40-50k":14.66,"50-60k":4.85,"60-80k":2.87,"+80k":1.87},"5-10":{"20-30k":18.38,"30-40k":30.35,"40-50k":25.8,"50-60k":10.96,"60-80k":9.95,"+80k":4.55},"10-":{"20-30k":14.92,"30-40k":26.81,"40-50k":28.44,"50-60k":15.15,"60-80k":10.26,"+80k":4.43}},{"role":"Product Manager","0-2":{"20-30k":43.7,"30-40k":30.37,"40-50k":11.11,"50-60k":6.67,"60-80k":5.19,"+80k":2.96},"2-5":{"20-30k":11.21,"30-40k":27.16,"40-50k":32.6,"50-60k":16.81,"60-80k":9.68,"+80k":2.55},"5-10":{"20-30k":3.81,"30-40k":12.01,"40-50k":31.92,"50-60k":21.96,"60-80k":21.82,"+80k":8.49},"10-":{"20-30k":2.51,"30-40k":5.62,"40-50k":18.78,"50-60k":21.53,"60-80k":35.05,"+80k":16.51}},{"role":"Project Manager & Delivery Manager","0-2":{"20-30k":50.07,"30-40k":19.91,"40-50k":12.52,"50-60k":8.96,"60-80k":6.4,"+80k":2.13},"2-5":{"20-30k":27.64,"30-40k":21,"40-50k":22.28,"50-60k":13.97,"60-80k":10.12,"+80k":4.98},"5-10":{"20-30k":9.39,"30-40k":14.73,"40-50k":26.45,"50-60k":18.86,"60-80k":20.44,"+80k":10.14},"10-":{"20-30k":2.86,"30-40k":6.88,"40-50k":22.4,"50-60k":24.65,"60-80k":32.32,"+80k":10.89}},{"role":"QA & Testing","0-2":{"20-30k":60.87,"30-40k":17.92,"40-50k":10.82,"50-60k":5.73,"60-80k":2.65,"+80k":2.01},"2-5":{"20-30k":32.41,"30-40k":26.46,"40-50k":19.23,"50-60k":10.8,"60-80k":6.94,"+80k":4.16},"5-10":{"20-30k":16.27,"30-40k":16.95,"40-50k":23.56,"50-60k":20.51,"60-80k":15.76,"+80k":6.95},"10-":{"20-30k":8.26,"30-40k":15.9,"40-50k":29.66,"50-60k":19.57,"60-80k":19.27,"+80k":7.34}},{"role":"Scrum Master & Agile Coach","0-2":{"20-30k":62.89,"30-40k":22.68,"40-50k":6.19,"50-60k":6.19,"60-80k":1.03,"+80k":1.03},"2-5":{"20-30k":20.21,"30-40k":36.17,"40-50k":25,"50-60k":11.7,"60-80k":4.26,"+80k":2.66},"5-10":{"20-30k":6.96,"30-40k":19.41,"40-50k":36.26,"50-60k":23.44,"60-80k":10.62,"+80k":3.3},"10-":{"20-30k":4.36,"30-40k":7.72,"40-50k":28.32,"50-60k":25.94,"60-80k":25.94,"+80k":7.72}},{"role":"Software Architect","0-2":{"20-30k":41.54,"30-40k":21.05,"40-50k":14.79,"50-60k":10.38,"60-80k":6.97,"+80k":5.26},"2-5":{"20-30k":14.24,"30-40k":13.74,"40-50k":20.24,"50-60k":16.57,"60-80k":19.41,"+80k":15.8},"5-10":{"20-30k":7.24,"30-40k":4.9,"40-50k":14.92,"50-60k":20.03,"60-80k":28.42,"+80k":24.5},"10-":{"20-30k":2.17,"30-40k":3.44,"40-50k":15.03,"50-60k":22.48,"60-80k":33.06,"+80k":23.82}},{"role":"SysAdmin","0-2":{"20-30k":80.99,"30-40k":13.03,"40-50k":2.46,"50-60k":0.7,"60-80k":1.76,"+80k":1.06},"2-5":{"20-30k":36.49,"30-40k":36.49,"40-50k":16.16,"50-60k":7.24,"60-80k":2.79,"+80k":0.84},"5-10":{"20-30k":19,"30-40k":31.15,"40-50k":24.61,"50-60k":10.59,"60-80k":9.97,"+80k":4.67},"10-":{"20-30k":10.87,"30-40k":26.09,"40-50k":26.27,"50-60k":16.67,"60-80k":14.49,"+80k":5.62}},{"role":"Tech Lead","0-2":{"20-30k":33.33,"30-40k":22.62,"40-50k":10.71,"50-60k":19.05,"60-80k":7.14,"+80k":7.14},"2-5":{"20-30k":7.82,"30-40k":23.66,"40-50k":28.19,"50-60k":20.37,"60-80k":14.4,"+80k":5.56},"5-10":{"20-30k":2.06,"30-40k":7.59,"40-50k":21.79,"50-60k":25.41,"60-80k":30.31,"+80k":12.85},"10-":{"20-30k":1.24,"30-40k":3.84,"40-50k":15.67,"50-60k":24.37,"60-80k":32.85,"+80k":22.03}}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/AverageSalaryByRole.styled.tsx

function AverageSalaryByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n"
    ]);
    AverageSalaryByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: min-content;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AverageSalaryByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 7.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    AverageSalaryByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var AverageSalaryByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88eaa7d6-0"
})(AverageSalaryByRole_styled_templateObject());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-88eaa7d6-1"
})(AverageSalaryByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-88eaa7d6-2"
})(AverageSalaryByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("text_disabled"), (0,theme/* color */.$_)("seq_blue_03"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("seq_blue_04"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("seq_blue_05"), (0,theme/* color */.$_)("seq_blue_06"), (0,theme/* color */.$_)("seq_blue_07"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_09"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/AverageSalaryByRole.tsx



var data = salary_by_role_and_experience_namespaceObject;
var AverageSalaryByRole = function(param) {
    var experience = param.experience;
    var getClassColor = function(val) {
        if (val === 0) return "cell-color-1";
        if (val <= 5) return "cell-color-2";
        if (val <= 9) return "cell-color-3";
        if (val <= 14) return "cell-color-4";
        if (val <= 19) return "cell-color-5";
        if (val <= 24) return "cell-color-6";
        if (val <= 29) return "cell-color-7";
        return "cell-color-8";
    };
    var ranges = [
        "20-30k",
        "30-40k",
        "40-50k",
        "50-60k",
        "60-80k",
        "+80k"
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AverageSalaryByRole_styled_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€20-30K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€31-40K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€41-50K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€51-60K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "€61-80K"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: ">80K"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: data.map(function(row, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: row.role
                                }),
                                ranges.map(function(range) {
                                    var val = row[experience][range];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledValue, {
                                            className: getClassColor(val),
                                            children: [
                                                val.toFixed(1),
                                                "%"
                                            ]
                                        })
                                    }, range);
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var benefits_AverageSalaryByRole = (AverageSalaryByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/Benefits.constants.tsx


var AVERAGESALARYBYROLEANDEXPERIENCETABS = function(t) {
    return {
        label: t("mantechcar25.benefits.average-salary-role.experience"),
        tabsName: "averageSalaryByRoleAndExperience",
        tabs: [
            {
                id: "exp-2",
                label: "<2 " + t("mantechcar25.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "0-2"
                })
            },
            {
                id: "exp2-5",
                label: "2-5 " + t("mantechcar25.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "2-5"
                })
            },
            {
                id: "exp5-10",
                label: "5-10 " + t("mantechcar25.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "5-10"
                })
            },
            {
                id: "exp+10",
                label: ">10 " + t("mantechcar25.benefits.average-salary-role.years"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_AverageSalaryByRole, {
                    experience: "10-"
                }),
                defaultChecked: true
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/sectionHero/SectionHero.styled.tsx

function SectionHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  position: relative;\n  background-color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    SectionHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.4;\n  z-index: 1;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    SectionHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    max-width: 25rem;\n  }\n  @media (min-width: ",
        ") {\n    max-width: 34rem;\n  }\n"
    ]);
    SectionHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SectionHero_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  color: var(--headingColor);\n"
    ]);
    SectionHero_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ",
        ";\n  font-family: ",
        ";\n  margin-bottom: ",
        ";\n\n  &::before {\n    background-color: var(--headingColor);\n    height: ",
        ";\n    top: calc(",
        " * -1);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  max-width: ",
        ";\n  margin: 0 auto;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin-top: 0;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  &::before,\n  &::after {\n    content: '';\n    height: 1px;\n    background-color: ",
        ";\n    flex-grow: 1;\n  }\n\n  &::before {\n    @media (max-width: ",
        ") {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-0"
})(SectionHero_styled_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("sun_100"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-1"
})(SectionHero_styled_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var StyledHeroImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-43853e98-2"
})(SectionHero_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("xl"));
var StyledHeroContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-3"
})(SectionHero_styled_templateObject3());
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading1 */.nL).withConfig({
    componentId: "sc-43853e98-4"
})(_templateObject4(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"));
var StyledHeroDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-43853e98-5"
})(_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43853e98-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl4"));
var StyledDataTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-43853e98-7"
})(_templateObject7(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("white"), (0,theme/* screen */.sp)("mdMax"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/Benefits.styled.tsx

function Benefits_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Benefits_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5f5a26a-0"
})(Benefits_styled_templateObject(), StyledHero, (0,theme/* color */.$_)("cyan_100"), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("cyan_500"));

;// CONCATENATED MODULE: ./data/mantechcar25/salary-by-english-level.json
var salary_by_english_level_namespaceObject = JSON.parse('[{"years":{"en":"<2 years","es":"<2 años"},"basic":29302,"intermediate":29909,"fluent":29503,"native":32064},{"years":{"en":"2-5 years","es":"2-5 años"},"basic":36098,"intermediate":38936,"fluent":41462,"native":45334},{"years":{"en":"5-10 years","es":"5-10 años"},"basic":43394,"intermediate":51883,"fluent":57792,"native":64852},{"years":{"en":">10 years","es":">10 años"},"basic":49533,"intermediate":55749,"fluent":70527,"native":83920}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(61660);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/LineChart.js
var LineChart = __webpack_require__(32908);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(25556);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(3131);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(47857);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Legend.js + 1 modules
var Legend = __webpack_require__(55734);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(63004);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/recharts/Recharts.styled.tsx

function Recharts_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    overflow-x: auto;\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    border-radius: ",
        " !important;\n    flex: 0 0 auto;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n  }\n  &.dark {\n    .recharts-text {\n      fill: ",
        ";\n    }\n    .recharts-legend-item-text {\n      color: ",
        " !important;\n    }\n    .recharts-cartesian-axis-line {\n      stroke: ",
        ";\n    }\n  }\n  &.skills {\n    .recharts-text {\n      fill: ",
        ";\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.methodology {\n    .recharts-text {\n      font-size: ",
        ";\n      text-transform: unset;\n    }\n  }\n  &.gender-by-role {\n    .recharts-text {\n      font-size: ",
        ";\n    }\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-label-list {\n    text-transform: inherit;\n    fill: ",
        ";\n    transform: translateZ(0);\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  &.legend-top {\n    .recharts-legend-wrapper {\n      top: 0;\n      bottom: unset !important;\n    }\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    margin-right: ",
        " !important;\n    display: flex !important;\n    align-items: center;\n  }\n\n  &.gender .recharts-legend-item {\n    display: inline-flex !important;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n\n  .recharts-default-legend {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  &.vertical-legend {\n    .recharts-default-legend {\n      flex-direction: column;\n    }\n  }\n\n  &.xAxisLabel {\n    .recharts-cartesian-axis-tick .recharts-text {\n      text-transform: initial;\n    }\n  }\n\n  &.treemap {\n    text {\n      fill: ",
        ";\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      stroke: none;\n      filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.3));\n    }\n  }\n"
    ]);
    Recharts_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledRecharts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4110a78-0"
})(Recharts_styled_templateObject(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("xs2"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/charts/SalaryByEnglishLevel.tsx






var SalaryByEnglishLevel = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: salary_by_english_level_namespaceObject,
                    margin: {
                        top: 45,
                        right: 35,
                        left: 20,
                        bottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: function(data) {
                                return data.years[locale || "en"];
                            },
                            tickLine: false,
                            axisLine: true,
                            tickMargin: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "number",
                            tickLine: false,
                            axisLine: true,
                            tickMargin: 10,
                            tickFormatter: function(tick) {
                                return "€".concat((Math.sign(tick) * (Math.abs(tick) / 1000)).toFixed(0), "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#d9ceff"
                            },
                            labelStyle: {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                borderBottom: "1px solid #837e93",
                                marginBottom: "8px",
                                fontSize: "12px"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "€".concat(value.toLocaleString(locale));
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                top: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "monotone",
                            dataKey: "basic",
                            stroke: "#1B9D76",
                            name: t("mantechcar25.benefits.english.basic")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "monotone",
                            dataKey: "intermediate",
                            stroke: "#D95F02",
                            name: t("mantechcar25.benefits.english.intermediate")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "monotone",
                            dataKey: "fluent",
                            stroke: "#746FB3",
                            name: t("mantechcar25.benefits.english.fluent")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "monotone",
                            dataKey: "native",
                            stroke: "#E7278A",
                            name: t("mantechcar25.benefits.english.native")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SalaryByEnglishLevel = (SalaryByEnglishLevel);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./data/mantechcar25/location-preference.json
var location_preference_namespaceObject = JSON.parse('[{"type":"remote","label":"mantechcar25.benefits.location.remote","prefersValue":59.1194474348,"offeredValue":63.0057803468,"fill":"#08519c"},{"type":"hybrid","label":"mantechcar25.benefits.location.hybrid","prefersValue":32.6588664241,"offeredValue":32.7552986513,"fill":"#50b4d3"},{"type":"onsite","label":"mantechcar25.benefits.location.onsite","prefersValue":8.2216861411,"offeredValue":4.2389210019,"fill":"#7bccc4"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/LocationPreference.styled.tsx

function LocationPreference_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  gap: ",
        ";\n  text-align: center;\n  margin: 0;\n  transition: 0.3s;\n"
    ]);
    LocationPreference_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: '100%';\n  height: '100%';\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: center;\n    align-items: end;\n    gap: ",
        ";\n  }\n"
    ]);
    LocationPreference_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  flex-grow: 1;\n  min-height: 400px;\n"
    ]);
    LocationPreference_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n  white-space: nowrap;\n"
    ]);
    LocationPreference_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  justify-items: center;\n  align-items: end;\n\n  > div {\n    border-radius: ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: calc(var(--coeficient) * 15rem);\n    aspect-ratio: 1/1;\n    grid-column-start: 1;\n    grid-row-start: 1;\n\n    @media (min-width: ",
        ") {\n      width: calc(var(--coeficient) * 19.5rem);\n    }\n  }\n"
    ]);
    LocationPreference_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    LocationPreference_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  &.reverse {\n    z-index: -1;\n  }\n"
    ]);
    LocationPreference_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function LocationPreference_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    LocationPreference_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  white-space: nowrap;\n\n  &::before {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n    background-color: ",
        ";\n  }\n\n  &:nth-child(2)::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-top: ",
        ";\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n\n  img {\n    max-width: 15.5rem;\n    border-radius: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n\n  p {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var StyledItem = styled_components_browser_esm/* default.figure.withConfig */.ZP.figure.withConfig({
    componentId: "sc-bb91af60-0"
})(LocationPreference_styled_templateObject(), (0,theme/* spacing */.W0)("md"));
var StyledItems = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-1"
})(LocationPreference_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var ChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-2"
})(LocationPreference_styled_templateObject2());
var StyledCaption = styled_components_browser_esm/* default.figcaption.withConfig */.ZP.figcaption.withConfig({
    componentId: "sc-bb91af60-3"
})(LocationPreference_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl2"));
var StyledValueContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-4"
})(LocationPreference_styled_templateObject4(), (0,theme/* radius */.q0)("full"), (0,theme/* screen */.sp)("lg"));
var StyledPrefersValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-5"
})(LocationPreference_styled_templateObject5(), (0,theme/* color */.$_)("seq_blue_08"));
var StyledOfferedValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-6"
})(LocationPreference_styled_templateObject6(), (0,theme/* color */.$_)("seq_blue_05"));
var StyledLegend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-7"
})(LocationPreference_styled_templateObject7(), (0,theme/* spacing */.W0)("sm"));
var StyledLegendItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_05"));
var LocationPreference_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* radius */.q0)("lg"));
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bb91af60-10"
})(_templateObject10());

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/PieChart.js
var PieChart = __webpack_require__(43454);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/Pie.js
var Pie = __webpack_require__(79941);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Cell.js
var Cell = __webpack_require__(11011);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/LocationPreference.tsx








var LocationPreference = function() {
    var _Math;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    var maxValue = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(location_preference_namespaceObject.map(function(obj) {
        if (obj.prefersValue >= obj.offeredValue) {
            return obj.prefersValue;
        } else {
            return obj.offeredValue;
        }
    })));
    var pieData = location_preference_namespaceObject.map(function(obj) {
        return {
            name: obj.label,
            value: obj.prefersValue,
            fill: obj.fill
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                className: "location preference",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                    height: 400,
                    width: 600,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "vertical",
                            align: "right",
                            verticalAlign: "middle",
                            iconType: "square",
                            width: 200,
                            wrapperStyle: {
                                paddingLeft: "20px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "".concat(value.toFixed(1), "%");
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                            data: pieData,
                            dataKey: "value",
                            cx: "50%",
                            cy: "50%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                    name: t("mantechcar25.benefits.location.remote")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                    name: t("mantechcar25.benefits.location.hybrid")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                    name: t("mantechcar25.benefits.location.onsite")
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItems, {
            children: location_preference_namespaceObject.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCaption, {
                            children: t(item.label)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledValueContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPrefersValue, {
                                style: {
                                    "--coeficient": item.prefersValue / maxValue
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLegend, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegendItem, {
                                children: [
                                    t("mantechcar25.benefits.location.preference"),
                                    ":",
                                    " ",
                                    item.prefersValue.toFixed(1),
                                    "%"
                                ]
                            })
                        })
                    ]
                }, item.type);
            })
        })
    });
};
/* harmony default export */ var benefits_LocationPreference = (LocationPreference);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/sectionHeroBoxes/SectionHeroBoxes.styled.tsx

function SectionHeroBoxes_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  max-width: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  margin: auto;\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: auto auto;\n  gap: 1.5rem;\n\n  @media (max-width: ",
        ") {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n    gap: 1rem;\n  }\n"
    ]);
    SectionHeroBoxes_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionHeroBoxes_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 2rem;\n  min-height: 100px;\n  background-color: ",
        ";\n  border-radius: 20px;\n  line-height: 36px;\n\n  color: ",
        ";\n  line-height: 1.5em;\n\n  @media (min-width: 0) {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    SectionHeroBoxes_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionHeroBoxes_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &::before {\n    content: '';\n    width: 80px;\n    height: 8px;\n    flex-shrink: 0;\n    background-color: var(--headingColor);\n    margin-bottom: 1rem;\n  }\n\n  justify-content: start;\n\n  color: var(--headingColor);\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 120%;\n  min-height: 3.5em;\n\n  @media (min-width: 0) {\n    grid-column: 1 / 2;\n    grid-row: 1 / 2;\n    font-size: 1.8rem;\n    font-size: ",
        ";\n    padding: ",
        " ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    grid-column: 1 / 3;\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    grid-column: 1 / 3;\n    font-size: ",
        ";\n    padding: 3rem 2rem;\n  }\n"
    ]);
    SectionHeroBoxes_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SectionHeroBoxes_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 1 / 2;\n  grid-row: 2 / 3;\n  color: white;\n\n  @media (max-width: ",
        ") {\n    grid-column: 1 / 2;\n    grid-row: 2 / 3;\n  }\n"
    ]);
    SectionHeroBoxes_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SectionHeroBoxes_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-column: 2 / 3;\n  grid-row: 2 / 3;\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    SectionHeroBoxes_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var SectionHeroBoxes_styled_StyledContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3c55c97e-0"
})(SectionHeroBoxes_styled_templateObject(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"));
var BaseBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3c55c97e-1"
})(SectionHeroBoxes_styled_templateObject1(), function(props) {
    return props.$backgroundColor;
}, function(props) {
    return props.$color ? props.$color : "var(--headingColor)";
}, (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"));
var StyledBoxOne = (0,styled_components_browser_esm/* default */.ZP)(BaseBox).withConfig({
    componentId: "sc-3c55c97e-2"
})(SectionHeroBoxes_styled_templateObject2(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"));
var StyledBoxTwo = (0,styled_components_browser_esm/* default */.ZP)(BaseBox).withConfig({
    componentId: "sc-3c55c97e-3"
})(SectionHeroBoxes_styled_templateObject3(), (0,theme/* screen */.sp)("md"));
var StyledBoxThree = (0,styled_components_browser_esm/* default */.ZP)(BaseBox).withConfig({
    componentId: "sc-3c55c97e-4"
})(SectionHeroBoxes_styled_templateObject4(), (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/shared/sectionHeroBoxes/SectionHeroBoxes.tsx



var SectionHeroBoxes = function(param) {
    var boxOne = param.boxOne, boxTwo = param.boxTwo, boxThree = param.boxThree;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionHeroBoxes_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBoxOne, {
                $color: boxOne.textColor,
                $backgroundColor: boxOne.color,
                children: boxOne.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBoxTwo, {
                $color: boxTwo.textColor,
                $backgroundColor: boxTwo.color,
                children: boxTwo.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBoxThree, {
                $color: boxThree.textColor,
                $backgroundColor: boxThree.color,
                children: boxThree.text
            })
        ]
    });
};
/* harmony default export */ var sectionHeroBoxes_SectionHeroBoxes = (SectionHeroBoxes);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/benefits/Benefits.tsx









var Benefits = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var averageSalaryByRoleAndExperienceTabs = AVERAGESALARYBYROLEANDEXPERIENCETABS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHeroBoxes_SectionHeroBoxes, {
                boxOne: {
                    text: t("mantechcar25.benefits.hero.title"),
                    color: "#08bdad"
                },
                boxTwo: {
                    text: t("mantechcar25.benefits.hero.desc"),
                    color: "#3ba0b7"
                },
                boxThree: {
                    text: t("mantechcar25.benefits.hero.descExtra"),
                    color: "#53e4c8"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.benefits.location.title"),
                desc: t("mantechcar25.benefits.location.desc"),
                descExtra: t("mantechcar25.benefits.location.text"),
                shareId: "locationpreference",
                emailSubject: t("mantechcar25.share-modal.location.email-subject"),
                emailMessage: t("mantechcar25.share-modal.location.email-text"),
                shareMessage: t("mantechcar25.share-modal.location.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_LocationPreference, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.benefits.average-salary-role.title"),
                desc: t("mantechcar25.benefits.average-salary-role.desc"),
                descExtra: t("mantechcar25.benefits.average-salary-role.descExtra"),
                shareId: "averagesalarybyroleandexperience",
                emailSubject: t("mantechcar25.share-modal.average-salary-role.email-subject"),
                emailMessage: t("mantechcar25.share-modal.average-salary-role.email-text"),
                shareMessage: t("mantechcar25.share-modal.average-salary-role.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: averageSalaryByRoleAndExperienceTabs.tabsName,
                    tabs: averageSalaryByRoleAndExperienceTabs.tabs,
                    label: averageSalaryByRoleAndExperienceTabs.label
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.benefits.english.title"),
                desc: t("mantechcar25.benefits.english.desc"),
                descExtra: t("mantechcar25.benefits.english.descExtra"),
                shareId: "salarybyenglishlevel",
                emailSubject: t("mantechcar25.share-modal.english.email-subject"),
                emailMessage: t("mantechcar25.share-modal.english.email-text"),
                shareMessage: t("mantechcar25.share-modal.english.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SalaryByEnglishLevel, {})
            })
        ]
    });
};
/* harmony default export */ var benefits_Benefits = (Benefits);

;// CONCATENATED MODULE: ./data/mantechcar25/location-offered.json
var location_offered_namespaceObject = JSON.parse('[{"year":"2021","remote":85.79234972677595,"hybrid":11.475409836065573,"onsite":2.73224043715847},{"year":"2022","remote":89.0951276102088,"hybrid":9.744779582366588,"onsite":1.160092807424594},{"year":"2023","remote":80.16528925619835,"hybrid":18.732782369146005,"onsite":1.1019283746556474},{"year":"2024","remote":67.34006734006735,"hybrid":28.95622895622896,"onsite":3.7037037037037033},{"year":"2025","remote":57.20720720720721,"hybrid":37.83783783783784,"onsite":4.954954954954955}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/companies/charts/LocationOffered.tsx





var LocationOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: location_offered_namespaceObject,
                    margin: {
                        top: 35,
                        right: 30,
                        left: 20,
                        bottom: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: "year",
                            type: "category",
                            tickLine: false,
                            tickMargin: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            domain: [
                                0,
                                100
                            ],
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            },
                            tickLine: false,
                            tickMargin: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            labelStyle: {
                                borderBottom: "1px solid #4d485c",
                                marginBottom: "6px",
                                fontWeight: 900
                            },
                            formatter: function(value) {
                                return value.toFixed(1) + "%";
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                top: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "linear",
                            dataKey: "onsite",
                            stroke: "#1B9D76",
                            name: t("mantechcar25.companies.locations-offered.onsite")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "linear",
                            dataKey: "remote",
                            stroke: "#D95F02",
                            name: t("mantechcar25.companies.locations-offered.remote")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            strokeWidth: 4,
                            dot: {
                                stroke: "#A29EAE",
                                strokeWidth: 1,
                                r: 4
                            },
                            type: "linear",
                            dataKey: "hybrid",
                            stroke: "#746FB3",
                            name: t("mantechcar25.companies.locations-offered.hybrid")
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LocationOffered = (LocationOffered);

;// CONCATENATED MODULE: ./data/mantechcar25/most-offered-perks.json
var most_offered_perks_namespaceObject = JSON.parse('[{"year":"2022","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Seguro de salud":4,"Pack de bienvenida":9,"Posibilidad de elegir equipo":7,"Retribución flexible":13,"Clases de idiomas":5,"Café":10,"Fruta y snacks":11,"Presupuesto para conferencias":6,"Vacaciones extra":8,"Descuento en productos de la empresa":12},{"year":"2023","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Seguro de salud":5,"Pack de bienvenida":7,"Posibilidad de elegir equipo":4,"Retribución flexible":13,"Clases de idiomas":6,"Café":8,"Fruta y snacks":9,"Presupuesto para conferencias":11,"Vacaciones extra":10,"Descuento en productos de la empresa":12},{"year":"2024","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Seguro de salud":5,"Pack de bienvenida":7,"Posibilidad de elegir equipo":4,"Retribución flexible":13,"Clases de idiomas":8,"Café":11,"Fruta y snacks":12,"Presupuesto para conferencias":6,"Vacaciones extra":9,"Descuento en productos de la empresa":10},{"year":"2025","Dinámicas y eventos de teambuilding":1,"Presupuesto para formación":2,"Eventos de formación internos":3,"Seguro de salud":4,"Pack de bienvenida":5,"Posibilidad de elegir equipo":6,"Retribución flexible":7,"Clases de idiomas":8,"Café":9,"Fruta y snacks":10,"Presupuesto para conferencias":11,"Vacaciones extra":12,"Descuento en productos de la empresa":13}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/companies/charts/MostOfferedPerks.tsx






var MostOfferedPerks = function() {
    var keyToSlug = function keyToSlug(key) {
        return key.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
    };
    var getPositionOfKey = function getPositionOfKey(data, key) {
        return data[key];
    };
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var keysFromData = (0,_to_consumable_array/* default */.Z)(new Set(most_offered_perks_namespaceObject.flatMap(function(obj) {
        return Object.keys(obj);
    }))).filter(function(key) {
        return key !== "year";
    });
    var colors = [
        "#BDB9DA",
        "#8DD3C7",
        "#FB8274",
        "#7EAFD3",
        "#FDB563",
        "#B3DE68",
        "#666666",
        "#BC7FBD",
        "#CDEBC6",
        "#FFEE70",
        "#FFA07A",
        "#FF82A9",
        "#FFB7B2",
        "#FFD3B5",
        "#FF3E4E",
        "#FF6F61",
        "#FF9B85",
        "#FFC1A"
    ];
    var CustomTickLabelLeft = Object.keys(most_offered_perks_namespaceObject[0]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_offered_perks_namespaceObject[0], a) - getPositionOfKey(most_offered_perks_namespaceObject[0], b);
    }).map(function(key) {
        return t("mantechcar25.companies.most-offered-perks.".concat(keyToSlug(key)));
    });
    var CustomTickLeft = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "end",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelLeft[payload.value - 1]
            })
        });
    };
    var CustomTickLabelRight = Object.keys(most_offered_perks_namespaceObject[most_offered_perks_namespaceObject.length - 1]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_offered_perks_namespaceObject[most_offered_perks_namespaceObject.length - 1], a) - getPositionOfKey(most_offered_perks_namespaceObject[most_offered_perks_namespaceObject.length - 1], b);
    }).map(function(key) {
        return t("mantechcar25.companies.most-offered-perks.".concat(keyToSlug(key)));
    });
    var CustomTickRight = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "start",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelRight[payload.value - 1]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 500,
                width: "99%",
                minWidth: 850,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: most_offered_perks_namespaceObject,
                    margin: {
                        top: 20,
                        right: 250,
                        left: 250,
                        bottom: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: "year",
                            padding: {
                                left: 20,
                                right: 20
                            },
                            axisLine: false,
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "left",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickLeft, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "right",
                            orientation: "right",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickRight, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        keysFromData.map(function(key, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                type: "linear",
                                yAxisId: "left",
                                dataKey: key,
                                stroke: colors[index],
                                strokeWidth: 4,
                                dot: {
                                    stroke: "#A29EAE",
                                    strokeWidth: 1,
                                    r: 4
                                }
                            }, key);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            yAxisId: "right",
                            hide: true
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostOfferedPerks = (MostOfferedPerks);

;// CONCATENATED MODULE: ./data/mantechcar25/most-wanted-roles.json
var most_wanted_roles_namespaceObject = JSON.parse('[{"year":"2022","Backend Developer":1,"Frontend Developer":2,"DevOps & Infrastructure & SRE":3,"Mobile Developer":4,"Full-Stack Developer":5,"Data Engineer":6,"QA & Testing":7,"Tech Lead":8,"Product Manager":9,"Engineering Management":10,"Product Design (UI/UX)":11,"SysAdmin":12,"Software Architect":13,"Data Scientist":14,"Project Manager & Delivery Manager":15,"Data Analyst & BI":16},{"year":"2023","Backend Developer":1,"Frontend Developer":2,"Full-Stack Developer":3,"DevOps & Infrastructure & SRE":4,"Tech Lead":5,"Mobile Developer":6,"SysAdmin":7,"Software Architect":8,"QA & Testing":9,"Data Engineer":10,"Project Manager & Delivery Manager":11,"Engineering Management":12,"Product Design (UI/UX)":13,"Data Analyst & BI":14,"Product Manager":15,"Data Scientist":16},{"year":"2024","Backend Developer":1,"Full-Stack Developer":2,"Frontend Developer":3,"DevOps & Infrastructure & SRE":4,"Tech Lead":5,"Project Manager & Delivery Manager":6,"Data Engineer":7,"SysAdmin":8,"Mobile Developer":9,"Engineering Management":10,"Software Architect":11,"Product Manager":12,"Data Analyst & BI":13,"QA & Testing":14,"Data Scientist":15,"Product Design (UI/UX)":16},{"year":"2025","Backend Developer":1,"Full-Stack Developer":2,"Frontend Developer":3,"DevOps & Infrastructure & SRE":4,"Software Architect":5,"Tech Lead":6,"Data Engineer":7,"SysAdmin":8,"Data Scientist":9,"Project Manager & Delivery Manager":10,"Engineering Management":11,"Mobile Developer":12,"Data Analyst & BI":13,"Product Manager":14,"Product Design (UI/UX)":15,"QA & Testing":16}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/companies/charts/MostWantedRoles.tsx





var MostWantedRoles = function() {
    var getPositionOfKey = function getPositionOfKey(data, key) {
        return data[key];
    };
    var keysFromData = (0,_to_consumable_array/* default */.Z)(new Set(most_wanted_roles_namespaceObject.flatMap(function(obj) {
        return Object.keys(obj);
    }))).filter(function(key) {
        return key !== "year";
    });
    var colors = [
        "#BDB9DA",
        "#8DD3C7",
        "#FB8274",
        "#7EAFD3",
        "#FDB563",
        "#B3DE68",
        "#666666",
        "#BC7FBD",
        "#CDEBC6",
        "#FFEE70",
        "#FFA07A",
        "#FF82A9",
        "#FFB7B2",
        "#FFD3B5",
        "#FF3E4E",
        "#FF6F61",
        "#FF9B85",
        "#FFC1A"
    ];
    var CustomTickLabelLeft = Object.keys(most_wanted_roles_namespaceObject[0]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_wanted_roles_namespaceObject[0], a) - getPositionOfKey(most_wanted_roles_namespaceObject[0], b);
    });
    var CustomTickLeft = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "end",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelLeft[payload.value - 1]
            })
        });
    };
    var CustomTickLabelRight = Object.keys(most_wanted_roles_namespaceObject[most_wanted_roles_namespaceObject.length - 1]).filter(function(key) {
        return key !== "year";
    }).sort(function(a, b) {
        return getPositionOfKey(most_wanted_roles_namespaceObject[most_wanted_roles_namespaceObject.length - 1], a) - getPositionOfKey(most_wanted_roles_namespaceObject[most_wanted_roles_namespaceObject.length - 1], b);
    });
    var CustomTickRight = function(param) {
        var x = param.x, y = param.y, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            transform: "translate(".concat(x, ",").concat(y, ")"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                x: 0,
                y: 0,
                dy: 5,
                textAnchor: "start",
                fontSize: 16,
                fill: "#353241",
                stroke: "#353241",
                strokeOpacity: "0.2",
                children: CustomTickLabelRight[payload.value - 1]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 500,
                width: "99%",
                minWidth: 850,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LineChart/* LineChart */.w, {
                    width: 500,
                    height: 300,
                    data: most_wanted_roles_namespaceObject,
                    margin: {
                        top: 20,
                        right: 250,
                        left: 250,
                        bottom: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            dataKey: "year",
                            padding: {
                                left: 20,
                                right: 20
                            },
                            axisLine: false,
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "left",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickLeft, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            yAxisId: "right",
                            orientation: "right",
                            domain: [
                                1,
                                keysFromData.length
                            ],
                            interval: 0,
                            tickCount: keysFromData.length,
                            reversed: true,
                            tick: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTickRight, {}),
                            axisLine: false,
                            tickLine: false,
                            padding: {
                                bottom: 20
                            }
                        }),
                        keysFromData.map(function(key, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                                type: "linear",
                                yAxisId: "left",
                                dataKey: key,
                                stroke: colors[index],
                                strokeWidth: 4,
                                dot: {
                                    stroke: "#A29EAE",
                                    strokeWidth: 1,
                                    r: 4
                                }
                            }, key);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            type: "linear",
                            yAxisId: "right",
                            hide: true
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostWantedRoles = (MostWantedRoles);

;// CONCATENATED MODULE: ./data/mantechcar25/salary-offered-vs-wanted.json
var salary_offered_vs_wanted_namespaceObject = JSON.parse('[{"role":"Engineering Management","desired":59561,"offered":61014},{"role":"Tech Lead","desired":56005,"offered":56183},{"role":"Software Architect","desired":54051,"offered":57739},{"role":"Product Manager","desired":48887,"offered":52513},{"role":"DevOps & Infrastructure & SRE","desired":46100,"offered":48935},{"role":"Scrum Master & Agile Coach","desired":44049,"offered":44000},{"role":"Project Manager & Delivery Manager","desired":42873,"offered":43049},{"role":"Machine Learning Engineer","desired":41746,"offered":64845},{"role":"Data Engineer","desired":40884,"offered":50785},{"role":"Mobile Developer","desired":38606,"offered":47611},{"role":"Backend Developer","desired":38080,"offered":44380},{"role":"Data Scientist","desired":37062,"offered":49465},{"role":"Full-Stack Developer","desired":37005,"offered":45493},{"role":"SysAdmin","desired":36476,"offered":37129},{"role":"QA & Testing","desired":36382,"offered":38167},{"role":"Data Analyst & BI","desired":35089,"offered":45889},{"role":"Frontend Developer","desired":34238,"offered":42808},{"role":"Product Design (UI/UX)","desired":31661,"offered":39327}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(80739);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(24908);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/companies/charts/SalaryOfferedVsWanted.tsx






var SalaryOfferedVsWanted = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "xAxisLabel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 950,
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: salary_offered_vs_wanted_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick / 1000, "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "€".concat(value.toLocaleString(locale));
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "offered",
                            name: t("mantechcar25.companies.salary-offered-wanted.offered"),
                            fill: "#7EAFD3",
                            barSize: 8,
                            radius: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "desired",
                            name: t("mantechcar25.companies.salary-offered-wanted.desired"),
                            fill: "#8DD3C7",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SalaryOfferedVsWanted = (SalaryOfferedVsWanted);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/companies/Companies.styled.tsx

function Companies_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Companies_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Companies_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c12abc1-0"
})(Companies_styled_templateObject(), StyledHero, (0,theme/* color */.$_)("purple_100"), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("purple_500"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/companies/Companies.tsx









var Companies = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Companies_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHeroBoxes_SectionHeroBoxes, {
                boxOne: {
                    text: t("mantechcar25.companies.hero.title"),
                    color: "#b3a2f1"
                },
                boxTwo: {
                    text: t("mantechcar25.companies.hero.desc"),
                    color: "#7d64d6"
                },
                boxThree: {
                    text: t("mantechcar25.companies.hero.descExtra"),
                    color: "#e6dfff"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.companies.salary-offered-wanted.title"),
                desc: t("mantechcar25.companies.salary-offered-wanted.desc"),
                descExtra: t("mantechcar25.companies.salary-offered-wanted.descExtra"),
                shareId: "salaryofferedvswanted",
                emailSubject: t("mantechcar25.share-modal.salary-offered-wanted.email-subject"),
                emailMessage: t("mantechcar25.share-modal.salary-offered-wanted.email-text"),
                shareMessage: t("mantechcar25.share-modal.salary-offered-wanted.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SalaryOfferedVsWanted, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.companies.most-wanted-roles.title"),
                desc: t("mantechcar25.companies.most-wanted-roles.desc"),
                descExtra: t("mantechcar25.companies.most-wanted-roles.descExtra"),
                shareId: "mostwantedroles",
                emailSubject: t("mantechcar25.share-modal.most-wanted-roles.email-subject"),
                emailMessage: t("mantechcar25.share-modal.most-wanted-roles.email-text"),
                shareMessage: t("mantechcar25.share-modal.most-wanted-roles.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostWantedRoles, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.companies.most-offered-perks.title"),
                desc: t("mantechcar25.companies.most-offered-perks.desc"),
                descExtra: t("mantechcar25.companies.most-offered-perks.descExtra"),
                shareId: "mostofferedperks",
                emailSubject: t("mantechcar25.share-modal.most-offered-perks.email-subject"),
                emailMessage: t("mantechcar25.share-modal.most-offered-perks.email-text"),
                shareMessage: t("mantechcar25.share-modal.most-offered-perks.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostOfferedPerks, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.companies.locations-offered.title"),
                desc: t("mantechcar25.companies.locations-offered.desc"),
                shareId: "locationoffered",
                emailSubject: t("mantechcar25.share-modal.locations-offered.email-subject"),
                emailMessage: t("mantechcar25.share-modal.locations-offered.email-text"),
                shareMessage: t("mantechcar25.share-modal.locations-offered.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LocationOffered, {})
            })
        ]
    });
};
/* harmony default export */ var companies_Companies = (Companies);

;// CONCATENATED MODULE: ./data/mantechcar25/female-representation-by-role.json
var female_representation_by_role_namespaceObject = JSON.parse('{"nodes":[{"name":"Total","fill":"#17BECF"},{"name":"Backend","fill":"#2CA02C"},{"name":"Frontend","fill":"#D62728"},{"name":"Tech Lead","fill":"#9467BD"},{"name":"Software","fill":"#8C564B"},{"name":"Data","fill":"#E377C2"},{"name":"Diseño","fill":"#17BECF"},{"name":"Marketing","fill":"#2CA02C"},{"name":"Producto","fill":"#D62728"},{"name":"Otros","fill":"#9467BD"}],"links":[{"source":0,"target":1,"value":2837},{"source":0,"target":2,"value":2761},{"source":0,"target":3,"value":958},{"source":0,"target":4,"value":1461},{"source":0,"target":5,"value":1423},{"source":0,"target":6,"value":1396},{"source":0,"target":7,"value":729},{"source":0,"target":8,"value":1946},{"source":0,"target":9,"value":5809}]}');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/container/Layer.js
var Layer = __webpack_require__(84618);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/shape/Rectangle.js
var Rectangle = __webpack_require__(43624);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/Sankey.js
var Sankey = __webpack_require__(28776);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/charts/FemaleByRole.tsx






var FemalesByRole = function() {
    var locale = (0,router.useRouter)().locale;
    var CustomNode = function(param) {
        var x = param.x, y = param.y, height = param.height, index = param.index, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer/* Layer */.m, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rectangle/* Rectangle */.A, {
                    x: x,
                    y: y,
                    width: 20,
                    height: height,
                    fill: payload.fill,
                    fillOpacity: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2,
                    fontSize: "14",
                    fill: "#837E93",
                    children: payload.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2 + 14,
                    fontSize: "12",
                    stroke: "#1F1D26",
                    strokeOpacity: "0.5",
                    children: payload.value.toLocaleString(locale)
                })
            ]
        }, "CustomNode".concat(index));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 600,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sankey/* Sankey */.b, {
                    data: female_representation_by_role_namespaceObject,
                    node: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomNode, {}),
                    nodePadding: 30,
                    margin: {
                        top: 10,
                        right: 200,
                        bottom: 50
                    },
                    link: {
                        stroke: "#17BECF"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {})
                })
            })
        })
    });
};
/* harmony default export */ var FemaleByRole = (FemalesByRole);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ./data/mantechcar25/female-representation-vs-male-by-role.json
var female_representation_vs_male_by_role_namespaceObject = JSON.parse('{"nodes":[{"name":"Femenino","fill":"#17BECF"},{"name":"Masculino","fill":"#3EA1EE"},{"name":"Backend","fill":"#2CA02C"},{"name":"Frontend","fill":"#D62728"},{"name":"Tech Lead","fill":"#9467BD"},{"name":"Software","fill":"#8C564B"},{"name":"Data","fill":"#E377C2"},{"name":"Diseño","fill":"#17BECF"},{"name":"Marketing","fill":"#17BECF"},{"name":"Producto","fill":"#2CA02C"},{"name":"Otros","fill":"#D62728"}],"links":[{"source":0,"target":2,"value":2837},{"source":1,"target":2,"value":24140},{"source":0,"target":3,"value":2761},{"source":1,"target":3,"value":10901},{"source":0,"target":4,"value":958},{"source":1,"target":4,"value":11273},{"source":0,"target":5,"value":1461},{"source":1,"target":5,"value":9229},{"source":0,"target":6,"value":1423},{"source":1,"target":6,"value":5396},{"source":0,"target":7,"value":1396},{"source":1,"target":7,"value":1334},{"source":0,"target":8,"value":729},{"source":1,"target":8,"value":766},{"source":0,"target":9,"value":1946},{"source":1,"target":9,"value":3760},{"source":0,"target":10,"value":5809},{"source":1,"target":10,"value":21489}]}');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/charts/FemalesVsMalesByRole.tsx










var FemalesVsMalesByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    var CustomNode = function(param) {
        var x = param.x, y = param.y, height = param.height, index = param.index, payload = param.payload;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layer/* Layer */.m, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rectangle/* Rectangle */.A, {
                    x: x,
                    y: y,
                    width: 20,
                    height: height,
                    fill: payload.fill,
                    fillOpacity: "1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2,
                    fontSize: "14",
                    fill: "#837E93",
                    children: t(payload.name)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                    textAnchor: "start",
                    x: x + 26,
                    y: y + height / 2 + 14,
                    fontSize: "12",
                    stroke: "#1F1D26",
                    strokeOpacity: "0.5",
                    children: payload.value.toLocaleString(locale)
                })
            ]
        }, "CustomNode".concat(index));
    };
    var CustomLink = function(props) {
        var ref, ref1;
        var sourceX = props.sourceX, sourceY = props.sourceY, targetX = props.targetX, targetY = props.targetY, sourceControlX = props.sourceControlX, targetControlX = props.targetControlX, linkWidth = props.linkWidth, payload = props.payload, rest = (0,_object_without_properties/* default */.Z)(props, [
            "sourceX",
            "sourceY",
            "targetX",
            "targetY",
            "sourceControlX",
            "targetControlX",
            "linkWidth",
            "payload"
        ]);
        var ref2, ref3;
        var color = (ref3 = (ref2 = payload === null || payload === void 0 ? void 0 : (ref = payload.source) === null || ref === void 0 ? void 0 : ref.fill) !== null && ref2 !== void 0 ? ref2 : payload === null || payload === void 0 ? void 0 : (ref1 = payload.target) === null || ref1 === void 0 ? void 0 : ref1.fill) !== null && ref3 !== void 0 ? ref3 : "#999";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("path", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            d: "M".concat(sourceX, ",").concat(sourceY, "\n         C").concat(sourceControlX, ",").concat(sourceY, "\n          ").concat(targetControlX, ",").concat(targetY, "\n          ").concat(targetX, ",").concat(targetY),
            fill: "none",
            stroke: color,
            strokeWidth: linkWidth,
            strokeOpacity: 0.25
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 600,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sankey/* Sankey */.b, {
                    data: female_representation_vs_male_by_role_namespaceObject,
                    node: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomNode, {}),
                    link: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {}),
                    nodePadding: 25,
                    margin: {
                        top: 10,
                        right: 200,
                        bottom: 50
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {})
                })
            })
        })
    });
};
/* harmony default export */ var charts_FemalesVsMalesByRole = (FemalesVsMalesByRole);

;// CONCATENATED MODULE: ./data/mantechcar25/gender-comparison-by-role.json
var gender_comparison_by_role_namespaceObject = JSON.parse('[{"role":"Backend Developer","female":10,"male":90},{"role":"Data Analyst & BI","female":23,"male":77},{"role":"Data Engineer","female":12,"male":88},{"role":"Data Scientist","female":18,"male":82},{"role":"DevOps & Infrastructure & SRE","female":7,"male":93},{"role":"Engineering Management","female":8,"male":92},{"role":"Frontend Developer","female":16,"male":84},{"role":"Full-Stack Developer","female":11,"male":89},{"role":"Mobile Developer","female":10,"male":90},{"role":"Product Design (UI/UX)","female":48,"male":52},{"role":"Product Manager","female":28,"male":72},{"role":"Project Manager & Delivery Manager","female":29,"male":71},{"role":"QA & Testing","female":29,"male":71},{"role":"Software Architect","female":6,"male":94},{"role":"SysAdmin","female":6,"male":94},{"role":"Tech Lead","female":5,"male":95}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/charts/GenderComparison.tsx






var GenderComparison = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var genderByRole = gender_comparison_by_role_namespaceObject.sort(function(a, b) {
        return a.female > b.female ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "gender gender-by-role",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 550,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: genderByRole,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            hide: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 210,
                            axisLine: false,
                            tickMargin: 10
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return value.toFixed(1) + "%";
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: -5
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "female",
                            stackId: "a",
                            name: t("mantechcar25.gender.females"),
                            barSize: 12,
                            radius: 5,
                            fill: "#974EA2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "male",
                            stackId: "a",
                            name: t("mantechcar25.gender.males"),
                            barSize: 12,
                            radius: 5,
                            fill: "#7EAFD3"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_GenderComparison = (GenderComparison);

;// CONCATENATED MODULE: ./data/mantechcar25/gender-salary-by-experience.json
var gender_salary_by_experience_namespaceObject = JSON.parse('[{"exp":"<2y","male":31278,"female":29972},{"exp":"2-5y","male":39618,"female":35865},{"exp":"5-10y","male":49922,"female":43520},{"exp":">10y","male":54961,"female":47116}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/charts/GenderSalaryByExperience.tsx







var GenderSalaryByExperience = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "gender",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 300,
                width: "99%",
                minWidth: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: gender_salary_by_experience_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "exp",
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick / 1000, "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#d9ceff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "".concat(value.toLocaleString(locale), "€");
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: -5
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "female",
                            name: t("mantechcar25.gender.females"),
                            barSize: 8,
                            radius: 5,
                            fill: "#974EA2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "male",
                            name: t("mantechcar25.gender.males"),
                            barSize: 8,
                            radius: 5,
                            fill: "#7EAFD3"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_GenderSalaryByExperience = (GenderSalaryByExperience);

;// CONCATENATED MODULE: ./data/mantechcar25/gender-salary-by-role.json
var gender_salary_by_role_namespaceObject = JSON.parse('[{"role":"Backend Developer","female":33697,"male":38511},{"role":"Data Analyst & BI","female":33522,"male":35404},{"role":"Data Engineer","female":36066,"male":41467},{"role":"Data Scientist","female":33661,"male":37688},{"role":"DevOps & Infrastructure & SRE","female":40376,"male":46469},{"role":"Engineering Management","female":49326,"male":60542},{"role":"Frontend Developer","female":30198,"male":34952},{"role":"Full-Stack Developer","female":31737,"male":37647},{"role":"Mobile Developer","female":36324,"male":38821},{"role":"Product Design (UI/UX)","female":29671,"male":33483},{"role":"Product Manager","female":44256,"male":50629},{"role":"Project Manager & Delivery Manager","female":37874,"male":44894},{"role":"QA & Testing","female":34468,"male":36925},{"role":"Software Architect","female":48440,"male":54354},{"role":"SysAdmin","female":32731,"male":36667},{"role":"Tech Lead","female":51952,"male":56088}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/charts/GenderSalaryByRole.tsx







var GenderSalaryByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    var genderSalaryByRole = gender_salary_by_role_namespaceObject.sort(function(a, b) {
        return a.female > b.female ? -1 : 1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "gender xAxisLabel",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 750,
                width: "99%",
                minWidth: 700,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: genderSalaryByRole,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick / 1000, "K");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#d9ceff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value) {
                                return "".concat(value.toLocaleString(locale), "€");
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: -5
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "female",
                            name: t("mantechcar25.gender.females"),
                            barSize: 12,
                            radius: 5,
                            fill: "#974EA2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "male",
                            name: t("mantechcar25.gender.males"),
                            barSize: 12,
                            radius: 5,
                            fill: "#7EAFD3"
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_GenderSalaryByRole = (GenderSalaryByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/Gender.styled.tsx

function Gender_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    background-color: ",
        ";\n  }\n\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Gender_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Gender_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n"
    ]);
    Gender_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Gender_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-66cc0a44-0"
})(Gender_styled_templateObject(), StyledHero, (0,theme/* color */.$_)("indigo_100"), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("indigo_500"));
var StyledSubsectionTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading3 */.aC).withConfig({
    componentId: "sc-66cc0a44-1"
})(Gender_styled_templateObject1(), (0,theme/* fontFamily */.I8)("sans"));

// EXTERNAL MODULE: ./components/shared/CustomSelect.tsx + 1 modules
var CustomSelect = __webpack_require__(88888);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
;// CONCATENATED MODULE: ./data/mantechcar25/gender-salary-by-role-and-experience.json
var gender_salary_by_role_and_experience_namespaceObject = JSON.parse('[{"role":"Account Manager","tier1":{"male":37250,"female":46136},"tier2":{"male":38653,"female":37950},"tier3":{"male":44753,"female":45812},"tier4":{"male":53954,"female":46000}},{"role":"Accounting & Financial Planning","tier1":{"male":28517,"female":27838},"tier2":{"male":33369,"female":34255},"tier3":{"male":47000,"female":39333},"tier4":{"male":60588,"female":45364}},{"role":"Accounts & Payroll","tier1":{"male":26538,"female":26143},"tier2":{"male":42455,"female":36538},"tier3":{"male":38778,"female":31000},"tier4":{"male":55400,"female":21667}},{"role":"Administration","tier1":{"male":28938,"female":33500},"tier2":{"male":34117,"female":34632},"tier3":{"male":33942,"female":42655},"tier4":{"male":38408,"female":38642}},{"role":"Backend Developer","tier1":{"male":29894,"female":28326},"tier2":{"male":38481,"female":36274},"tier3":{"male":47824,"female":43272},"tier4":{"male":51043,"female":47220}},{"role":"Brand & Creative Marketing","tier1":{"male":32183,"female":26983},"tier2":{"male":31323,"female":27439},"tier3":{"male":35130,"female":32652},"tier4":{"male":42047,"female":42317}},{"role":"Brand Design","tier1":{"male":25621,"female":26545},"tier2":{"male":26545,"female":26738},"tier3":{"male":31944,"female":31229},"tier4":{"male":38485,"female":34806}},{"role":"Business Operations & Strategy","tier1":{"male":30212,"female":29583},"tier2":{"male":38872,"female":34213},"tier3":{"male":49093,"female":45215},"tier4":{"male":64048,"female":60279}},{"role":"Content Marketing & Design","tier1":{"male":28331,"female":25878},"tier2":{"male":34039,"female":28046},"tier3":{"male":34280,"female":32274},"tier4":{"male":35378,"female":44194}},{"role":"Copywriter","tier1":{"male":26512,"female":33543},"tier2":{"male":33604,"female":26523},"tier3":{"male":38444,"female":33967},"tier4":{"male":32100,"female":37421}},{"role":"Corporate & Strategic Finance","tier1":{"male":34708,"female":42167},"tier2":{"male":44061,"female":36294},"tier3":{"male":56333,"female":45786},"tier4":{"male":58385,"female":63000}},{"role":"Customer Service & Support","tier1":{"male":26935,"female":25852},"tier2":{"male":29608,"female":31907},"tier3":{"male":35009,"female":35830},"tier4":{"male":41714,"female":43409}},{"role":"Customer Success & Account Management","tier1":{"male":30259,"female":26786},"tier2":{"male":35983,"female":28886},"tier3":{"male":45683,"female":40478},"tier4":{"male":51802,"female":44179}},{"role":"DBA","tier1":{"male":28940,"female":28750},"tier2":{"male":32515,"female":27333},"tier3":{"male":42047,"female":25333},"tier4":{"male":47956,"female":41615}},{"role":"Data Analyst & BI","tier1":{"male":28526,"female":29315},"tier2":{"male":36421,"female":37281},"tier3":{"male":44986,"female":42993},"tier4":{"male":50149,"female":42881}},{"role":"Data Engineer","tier1":{"male":32523,"female":33085},"tier2":{"male":42395,"female":38911},"tier3":{"male":52190,"female":47841},"tier4":{"male":57568,"female":46591}},{"role":"Data Scientist","tier1":{"male":31888,"female":31786},"tier2":{"male":42494,"female":39235},"tier3":{"male":51125,"female":44443},"tier4":{"male":55137,"female":45744}},{"role":"DevOps & Infrastructure & SRE","tier1":{"male":34509,"female":35023},"tier2":{"male":44354,"female":42975},"tier3":{"male":55053,"female":51415},"tier4":{"male":57531,"female":51700}},{"role":"Developer Advocate & Evangelist","tier1":{"male":27765,"female":26167},"tier2":{"male":45171,"female":32300},"tier3":{"male":54544,"female":41800},"tier4":{"male":62005,"female":45143}},{"role":"Director / General Manager","tier1":{"male":55947,"female":49700},"tier2":{"male":55645,"female":46444},"tier3":{"male":65404,"female":61692},"tier4":{"male":78673,"female":72195}},{"role":"Engineering Management","tier1":{"male":44286,"female":39190},"tier2":{"male":54980,"female":50000},"tier3":{"male":64878,"female":52100},"tier4":{"male":68138,"female":58186}},{"role":"Enterprise Sales","tier1":{"male":34000,"female":35333},"tier2":{"male":42214,"female":22750},"tier3":{"male":45810,"female":43200},"tier4":{"male":60387,"female":45000}},{"role":"Executive Assistant","tier1":{"male":45759,"female":31762},"tier2":{"male":45850,"female":35500},"tier3":{"male":33200,"female":31950},"tier4":{"male":56214,"female":49417}},{"role":"Finance Operations","tier1":{"male":26573,"female":28114},"tier2":{"male":35872,"female":37000},"tier3":{"male":47321,"female":61182},"tier4":{"male":55864,"female":61000}},{"role":"Frontend Developer","tier1":{"male":29222,"female":27753},"tier2":{"male":36580,"female":34276},"tier3":{"male":45464,"female":41119},"tier4":{"male":48696,"female":42244}},{"role":"Full-Stack Developer","tier1":{"male":29873,"female":27521},"tier2":{"male":37622,"female":34958},"tier3":{"male":47001,"female":44164},"tier4":{"male":50713,"female":46671}},{"role":"Generalist Marketing","tier1":{"male":25354,"female":24211},"tier2":{"male":28875,"female":27396},"tier3":{"male":39313,"female":34081},"tier4":{"male":46533,"female":45506}},{"role":"Generalist Recruitment","tier1":{"male":25154,"female":25867},"tier2":{"male":30484,"female":23918},"tier3":{"male":32182,"female":29721},"tier4":{"male":34542,"female":34583}},{"role":"Graphic & Motion Design","tier1":{"male":28276,"female":23275},"tier2":{"male":32328,"female":26900},"tier3":{"male":32022,"female":29156},"tier4":{"male":37690,"female":35500}},{"role":"Growth Manager","tier1":{"male":40000,"female":28167},"tier2":{"male":36422,"female":31429},"tier3":{"male":50934,"female":41310},"tier4":{"male":58058,"female":54571}},{"role":"Hardware Engineer","tier1":{"male":32247,"female":26625},"tier2":{"male":34043,"female":30500},"tier3":{"male":40020,"female":21667},"tier4":{"male":40469,"female":42800}},{"role":"Human Resources","tier1":{"male":25222,"female":27303},"tier2":{"male":31000,"female":27163},"tier3":{"male":41793,"female":33877},"tier4":{"male":51225,"female":39324}},{"role":"IT Manager","tier1":{"male":31152,"female":26071},"tier2":{"male":38732,"female":35520},"tier3":{"male":48921,"female":48920},"tier4":{"male":58641,"female":52688}},{"role":"Implementation & Solutions Engineer","tier1":{"male":31214,"female":40900},"tier2":{"male":39130,"female":38960},"tier3":{"male":50306,"female":44167},"tier4":{"male":59237,"female":53000}},{"role":"Layout Designer","tier1":{"male":24514,"female":22947},"tier2":{"male":29130,"female":25365},"tier3":{"male":35582,"female":30466},"tier4":{"male":38101,"female":35400}},{"role":"Lead Designer","tier1":{"male":39000,"female":25727},"tier2":{"male":36636,"female":29864},"tier3":{"male":40000,"female":42842},"tier4":{"male":51024,"female":43281}},{"role":"Lead Product Manager","tier1":{"male":46833,"female":40875},"tier2":{"male":52173,"female":38593},"tier3":{"male":55596,"female":57410},"tier4":{"male":66707,"female":60522}},{"role":"Legal","tier1":{"male":34611,"female":25800},"tier2":{"male":39909,"female":26000},"tier3":{"male":58500,"female":56000},"tier4":{"male":44667,"female":60714}},{"role":"MLOps","tier1":{"male":27132,"female":26750},"tier2":{"male":49667,"female":33857},"tier3":{"male":53225,"female":41000},"tier4":{"male":78727,"female":null}},{"role":"Machine Learning Engineer","tier1":{"male":29346,"female":28116},"tier2":{"male":41389,"female":37736},"tier3":{"male":54004,"female":48185},"tier4":{"male":59071,"female":48867}},{"role":"Mobile Developer","tier1":{"male":30107,"female":30065},"tier2":{"male":40874,"female":40543},"tier3":{"male":49390,"female":54683},"tier4":{"male":53972,"female":51905}},{"role":"Operations Generalist","tier1":{"male":27957,"female":30500},"tier2":{"male":39767,"female":34533},"tier3":{"male":44500,"female":42000},"tier4":{"male":54260,"female":54160}},{"role":"PR & Communications","tier1":{"male":30929,"female":24833},"tier2":{"male":32222,"female":27421},"tier3":{"male":35467,"female":34270},"tier4":{"male":39097,"female":36229}},{"role":"Performance Marketing","tier1":{"male":25682,"female":27267},"tier2":{"male":32556,"female":28137},"tier3":{"male":42358,"female":33318},"tier4":{"male":47184,"female":47625}},{"role":"Pre-Sales Engineer","tier1":{"male":32294,"female":27500},"tier2":{"male":45314,"female":39571},"tier3":{"male":50400,"female":29250},"tier4":{"male":60062,"female":47444}},{"role":"Product Analyst","tier1":{"male":30714,"female":33320},"tier2":{"male":37495,"female":37800},"tier3":{"male":42570,"female":40262},"tier4":{"male":45098,"female":41278}},{"role":"Product Design (UI/UX)","tier1":{"male":27795,"female":26317},"tier2":{"male":32794,"female":30640},"tier3":{"male":40980,"female":38034},"tier4":{"male":41735,"female":39053}},{"role":"Product Manager","tier1":{"male":31400,"female":34119},"tier2":{"male":41737,"female":38592},"tier3":{"male":50760,"female":47021},"tier4":{"male":58710,"female":52296}},{"role":"Product Marketing","tier1":{"male":26400,"female":25242},"tier2":{"male":36909,"female":29849},"tier3":{"male":42726,"female":38537},"tier4":{"male":54571,"female":47125}},{"role":"Product Owner","tier1":{"male":32035,"female":33026},"tier2":{"male":41039,"female":38233},"tier3":{"male":49506,"female":45134},"tier4":{"male":55561,"female":48453}},{"role":"Project Manager & Delivery Manager","tier1":{"male":33691,"female":32897},"tier2":{"male":41019,"female":38711},"tier3":{"male":51127,"female":43951},"tier4":{"male":54444,"female":49600}},{"role":"QA & Testing","tier1":{"male":30501,"female":31004},"tier2":{"male":37641,"female":35068},"tier3":{"male":46059,"female":41013},"tier4":{"male":48370,"female":43795}},{"role":"Release Engineer","tier1":{"male":28182,"female":20000},"tier2":{"male":44333,"female":null},"tier3":{"male":57471,"female":41000},"tier4":{"male":61571,"female":41000}},{"role":"Research Developer","tier1":{"male":29337,"female":30062},"tier2":{"male":38984,"female":38000},"tier3":{"male":51243,"female":36895},"tier4":{"male":58053,"female":55167}},{"role":"SEO Marketing","tier1":{"male":25727,"female":29769},"tier2":{"male":29414,"female":26729},"tier3":{"male":36476,"female":31432},"tier4":{"male":43557,"female":41586}},{"role":"Sales & Business Development","tier1":{"male":28466,"female":29488},"tier2":{"male":33095,"female":30861},"tier3":{"male":45884,"female":44045},"tier4":{"male":52835,"female":49356}},{"role":"Sales Leadership & Management","tier1":{"male":36667,"female":31778},"tier2":{"male":42200,"female":41429},"tier3":{"male":49929,"female":48316},"tier4":{"male":63745,"female":57263}},{"role":"Scrum Master & Agile Coach","tier1":{"male":28644,"female":26957},"tier2":{"male":38484,"female":33105},"tier3":{"male":44285,"female":40691},"tier4":{"male":51260,"female":47315}},{"role":"Security Engineer","tier1":{"male":33489,"female":29068},"tier2":{"male":46199,"female":43436},"tier3":{"male":54305,"female":47150},"tier4":{"male":55045,"female":48900}},{"role":"Social Media & Community","tier1":{"male":28745,"female":27074},"tier2":{"male":29103,"female":25684},"tier3":{"male":31788,"female":31414},"tier4":{"male":44315,"female":48816}},{"role":"Software Architect","tier1":{"male":36491,"female":36344},"tier2":{"male":51237,"female":52605},"tier3":{"male":60664,"female":52667},"tier4":{"male":61562,"female":57429}},{"role":"Support Engineer","tier1":{"male":31303,"female":23808},"tier2":{"male":31779,"female":38062},"tier3":{"male":39121,"female":33632},"tier4":{"male":44206,"female":38714}},{"role":"SysAdmin","tier1":{"male":25303,"female":22828},"tier2":{"male":32083,"female":28545},"tier3":{"male":39259,"female":43333},"tier4":{"male":43831,"female":38947}},{"role":"Tech Lead","tier1":{"male":37216,"female":57700},"tier2":{"male":44736,"female":43125},"tier3":{"male":54543,"female":51468},"tier4":{"male":60476,"female":55455}},{"role":"Technical Account Management","tier1":{"male":26200,"female":26500},"tier2":{"male":40282,"female":35875},"tier3":{"male":52896,"female":37500},"tier4":{"male":59135,"female":42125}},{"role":"Technical Recruitment","tier1":{"male":22333,"female":23608},"tier2":{"male":37500,"female":24760},"tier3":{"male":37727,"female":33091},"tier4":{"male":51250,"female":33208}},{"role":"Technical Writer","tier1":{"male":28387,"female":21455},"tier2":{"male":37500,"female":29438},"tier3":{"male":45200,"female":37250},"tier4":{"male":44289,"female":44933}},{"role":"Technical artist","tier1":{"male":24769,"female":23750},"tier2":{"male":29143,"female":20000},"tier3":{"male":42500,"female":null},"tier4":{"male":54333,"female":20000}},{"role":"UX Researcher","tier1":{"male":25340,"female":23200},"tier2":{"male":31765,"female":29281},"tier3":{"male":45419,"female":40717},"tier4":{"male":41633,"female":41370}},{"role":"UX Writer","tier1":{"male":24667,"female":23743},"tier2":{"male":31000,"female":25588},"tier3":{"male":49545,"female":34200},"tier4":{"male":40385,"female":39286}},{"role":"VP of Design","tier1":{"male":20000,"female":24000},"tier2":{"male":42600,"female":41000},"tier3":{"male":57667,"female":42000},"tier4":{"male":62259,"female":47286}},{"role":"VP of Engineering","tier1":{"male":46337,"female":37882},"tier2":{"male":55954,"female":52262},"tier3":{"male":69557,"female":56200},"tier4":{"male":88217,"female":79000}},{"role":"VP of Product","tier1":{"male":32333,"female":41000},"tier2":{"male":58062,"female":47000},"tier3":{"male":66161,"female":74333},"tier4":{"male":81826,"female":69571}}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/GenderCalculator.styled.tsx

function GenderCalculator_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  max-width: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  min-width: 18rem;\n  align-self: center;\n"
    ]);
    GenderCalculator_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        ";\n  color: ",
        ";\n"
    ]);
    GenderCalculator_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    gap: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  line-height: 1;\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function GenderCalculator_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    GenderCalculator_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var GenderCalculator_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-0"
})(GenderCalculator_styled_templateObject(), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl3"));
var StyledInputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-1"
})(GenderCalculator_styled_templateObject1(), (0,theme/* spacing */.W0)("lg"));
var StyledOutputs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-2"
})(GenderCalculator_styled_templateObject2(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("set1_04"));
var StyledOutput = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5fd430-3"
})(GenderCalculator_styled_templateObject3(), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("md"));
var StyledLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4f5fd430-4"
})(GenderCalculator_styled_templateObject4(), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"));
var GenderCalculator_styled_StyledValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-4f5fd430-5"
})(GenderCalculator_styled_templateObject5(), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl7"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl9"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/GenderCalculator.tsx








var GenderCalculator = function() {
    var ref = (0,react.useState)(), currentRole = ref[0], setCurrentRole = ref[1];
    var ref1 = (0,react.useState)(), currentYears = ref1[0], setCurrentYears = ref1[1];
    var ref2 = (0,react.useState)("--"), currentWomenSalary = ref2[0], setCurrentWomenSalary = ref2[1];
    var ref3 = (0,react.useState)("--"), currentMenSalary = ref3[0], setCurrentMenSalary = ref3[1];
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var ROLES = (0,react.useMemo)(function() {
        return gender_salary_by_role_and_experience_namespaceObject.map(function(param) {
            var role = param.role;
            return {
                label: role,
                value: role
            };
        });
    }, []);
    var YEARS = (0,react.useMemo)(function() {
        return [
            {
                label: "<2",
                value: "tier1"
            },
            {
                label: "2-5",
                value: "tier2"
            },
            {
                label: "5-10",
                value: "tier3"
            },
            {
                label: ">10",
                value: "tier4"
            }
        ];
    }, []);
    var handleRoleChange = function(param) {
        var value = param.value;
        setCurrentRole(value);
    };
    var handleYearsChange = function(param) {
        var value = param.value;
        setCurrentYears(value);
    };
    (0,react.useEffect)(function() {
        if (currentRole !== undefined && currentYears !== undefined) {
            var data = gender_salary_by_role_and_experience_namespaceObject.find(function(data) {
                return data.role === currentRole;
            });
            var _currentYears = data[currentYears], female = _currentYears.female, male = _currentYears.male;
            setCurrentMenSalary(String(parseFloat(male.toFixed(1))));
            setCurrentWomenSalary(String(parseFloat(female.toFixed(1))));
        } else {
            setCurrentMenSalary("--");
            setCurrentWomenSalary("--");
        }
    }, [
        currentRole,
        currentYears
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        label: t("mantechcar25.gender.calculator-experience.calculator.role"),
                        forId: "genderRole",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            defaultValue: gender_salary_by_role_namespaceObject[0].role,
                            id: "genderRole",
                            isSmall: true,
                            onChange: handleRoleChange,
                            options: ROLES,
                            matchOrder: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
                        label: t("mantechcar25.gender.calculator-experience.calculator.years"),
                        forId: "genderRole",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSelect/* default */.Z, {
                            defaultValue: YEARS[0].value,
                            id: "genderExperience",
                            isSmall: true,
                            onChange: handleYearsChange,
                            options: YEARS,
                            matchOrder: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutputs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("mantechcar25.gender.calculator-experience.calculator.women")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentWomenSalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutput, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLabel, {
                                children: t("mantechcar25.gender.calculator-experience.calculator.men")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GenderCalculator_styled_StyledValue, {
                                children: [
                                    "€",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: currentMenSalary
                                    }),
                                    "K"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var gender_GenderCalculator = (GenderCalculator);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/gender/Gender.tsx











var Gender = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Gender_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHeroBoxes_SectionHeroBoxes, {
                boxOne: {
                    text: t("mantechcar25.gender.hero.title"),
                    color: "#ffdfec"
                },
                boxTwo: {
                    text: t("mantechcar25.gender.hero.desc"),
                    color: "#974ea2"
                },
                boxThree: {
                    text: t("mantechcar25.gender.hero.descExtra"),
                    color: "#1e076e",
                    textColor: "#fff"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.gender.females-by-role.title"),
                desc: t("mantechcar25.gender.females-by-role.desc"),
                descExtra: t("mantechcar25.gender.females-by-role.descExtra"),
                shareId: "femalesbyrole",
                emailSubject: t("mantechcar25.share-modal.females-by-role.email-subject"),
                emailMessage: t("mantechcar25.share-modal.females-by-role.email-text"),
                shareMessage: t("mantechcar25.share-modal.females-by-role.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FemaleByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.gender.gender-by-role.title"),
                desc: t("mantechcar25.gender.gender-by-role.desc"),
                descExtra: t("mantechcar25.gender.gender-by-role.descExtra"),
                shareId: "genderbyrole",
                emailSubject: t("mantechcar25.share-modal.gender-by-role.email-subject"),
                emailMessage: t("mantechcar25.share-modal.gender-by-role.email-text"),
                shareMessage: t("mantechcar25.share-modal.gender-by-role.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_FemalesVsMalesByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.gender.gender-comparison.title"),
                desc: t("mantechcar25.gender.gender-comparison.desc"),
                descExtra: t("mantechcar25.gender.gender-comparison.descExtra"),
                shareId: "gendercomparison",
                emailSubject: t("mantechcar25.share-modal.gender-comparison.email-subject"),
                emailMessage: t("mantechcar25.share-modal.gender-comparison.email-text"),
                shareMessage: t("mantechcar25.share-modal.gender-comparison.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderComparison, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.gender.salary-by-gender.title"),
                desc: t("mantechcar25.gender.salary-by-gender.desc"),
                descExtra: t("mantechcar25.gender.salary-by-gender.descExtra"),
                shareId: "salarybygender",
                emailSubject: t("mantechcar25.share-modal.salary-by-gender.email-subject"),
                emailMessage: t("mantechcar25.share-modal.salary-by-gender.email-text"),
                shareMessage: t("mantechcar25.share-modal.salary-by-gender.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByRole, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sectionChart_SectionChart, {
                title: t("mantechcar25.gender.calculator-experience.title"),
                desc: t("mantechcar25.gender.calculator-experience.desc"),
                descExtra: t("mantechcar25.gender.calculator-experience.descExtra"),
                shareId: "gendersalarybyexperience",
                emailSubject: t("mantechcar25.share-modal.calculator-experience.email-subject"),
                emailMessage: t("mantechcar25.share-modal.calculator-experience.email-text"),
                shareMessage: t("mantechcar25.share-modal.calculator-experience.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubsectionTitle, {
                        children: t("mantechcar25.gender.calculator-experience.calculator.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(gender_GenderCalculator, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubsectionTitle, {
                        children: t("mantechcar25.gender.calculator-experience.salary-gender-experience.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_GenderSalaryByExperience, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var gender_Gender = (Gender);

// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/intro/Intro.constants.tsx
var INTRODATA = function(t, locale, manfreditesCount) {
    return [
        {
            value: "112.600",
            text: t("mantechcar25.data.people")
        },
        {
            value: "+8.000",
            text: t("mantechcar25.data.current")
        },
        {
            value: "54%",
            text: t("mantechcar25.data.companies")
        },
        {
            value: "+850",
            text: t("mantechcar25.data.time-to-hire")
        }
    ];
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/intro/Intro.styled.tsx

function Intro_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  margin: auto;\n"
    ]);
    Intro_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n\n  @media (min-width: 0) {\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    justify-content: space-between;\n    background-color: ",
        ";\n    border-radius: 16px;\n    padding: 1rem 1.5rem 0.5rem 1.5rem;\n  }\n"
    ]);
    Intro_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 0;\n  @media (min-width: ",
        ") {\n    max-width: 40%;\n    min-width: 25%;\n    align-self: flex-end;\n  }\n  @media (min-width: ",
        ") {\n    max-width: 22rem;\n  }\n"
    ]);
    Intro_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  gap: ",
        ";\n\n  padding: 1rem;\n\n  color: var(--headingColor);\n  font-family: 'BigShoulders', sans-serif;\n\n  @media (max-width: ",
        ") {\n    order: 1;\n    font-size: ",
        ";\n\n    font-family: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    &::before {\n      content: '';\n      width: 80px;\n      height: 8px;\n      flex-shrink: 0;\n      background-color: var(--headingColor);\n      margin-bottom: 1rem;\n    }\n\n    order: 0;\n    text-transform: uppercase;\n    font-size: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  .pretitle {\n    margin: 0;\n    text-transform: uppercase;\n\n    @media (min-width: 0) {\n      font-size: ",
        ";\n      line-height: 24px;\n      font-weight: 900;\n      letter-spacing: 5.6px;\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      letter-spacing: unset;\n      line-height: 1rem;\n      font-weight: 700;\n    }\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      font-weight: ",
        ";\n      letter-spacing: unset;\n    }\n  }\n"
    ]);
    Intro_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n\n  @media (min-width: ",
        ") {\n    margin-top: ",
        ";\n  }\n"
    ]);
    Intro_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n  line-height: 1.5;\n\n  &:not(.display-full-text) {\n    display: -webkit-box;\n    -webkit-line-clamp: 6;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n\n    @media (min-width: ",
        ") {\n      -webkit-line-clamp: 11;\n    }\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    Intro_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    Intro_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        ";\n\n  &::before {\n    content: '\uD83C\uDFC3‍♂️\uD83D\uDCA8';\n    display: block;\n  }\n"
    ]);
    Intro_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    Intro_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin-top: 0;\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  &::before,\n  &::after {\n    content: '';\n    height: 1px;\n    background-color: ",
        ";\n    flex-grow: 1;\n  }\n"
    ]);
    Intro_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Intro_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n"
    ]);
    Intro_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.25;\n  flex-direction: column;\n  gap: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  flex-shrink: 0;\n  width: auto;\n  text-align: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  flex-direction: column;\n  text-align: center;\n\n  &::before {\n    content: '';\n    display: block;\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var Intro_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-0"
})(Intro_styled_templateObject(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-1"
})(Intro_styled_templateObject1(), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("mint_700"));
var Intro_styled_StyledHeroImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-c74b589-2"
})(Intro_styled_templateObject2(), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("xl"));
var Intro_styled_StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading1 */.nL).withConfig({
    componentId: "sc-c74b589-3"
})(Intro_styled_templateObject3(), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl10"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* screen */.sp)("xl"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontWeight */.Ue)("bold"));
var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-4"
})(Intro_styled_templateObject4(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl4"));
var StyledIntroText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-5"
})(Intro_styled_templateObject5(), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"));
var StyledReadMoreButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
    componentId: "sc-c74b589-6"
})(Intro_styled_templateObject6(), (0,theme/* screen */.sp)("md"));
var StyledIntroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography_styled/* Heading2 */.XJ).withConfig({
    componentId: "sc-c74b589-7"
})(Intro_styled_templateObject7(), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-8"
})(Intro_styled_templateObject8(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var Intro_styled_StyledDataTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-c74b589-9"
})(Intro_styled_templateObject9(), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* color */.$_)("midnight_900"));
var StyledDataList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-10"
})(Intro_styled_templateObject10(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c74b589-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xs"));
var StyledDataValue = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c74b589-12"
})(_templateObject12(), (0,theme/* color */.$_)("navy_500"), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* fontSize */.JB)("xl6"));
var StyledDataContent = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c74b589-13"
})(_templateObject13(), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("navy_200"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/intro/Intro.tsx










var Intro = function(param) {
    var manfreditesCount = param.manfreditesCount;
    var checkLineClamp = function checkLineClamp() {
        if (clampableText.current && clampableText.current.clientHeight < clampableText.current.scrollHeight) {
            setdisplayReadMore(true);
        } else {
            setdisplayReadMore(false);
        }
    };
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    var introData = INTRODATA(t, locale, manfreditesCount);
    var ref = (0,react.useState)(false), displayReadMore = ref[0], setdisplayReadMore = ref[1];
    var clampableText = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        checkLineClamp();
    }, []);
    var ref1 = (0,react.useState)(false), showAllText = ref1[0], setShowAllText = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledHero, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledHeroTitle, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "pretitle",
                                children: t("mantechcar25.hero.pre-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    t("mantechcar25.hero.title"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "year",
                                        children: "2025"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledHeroImage, {
                        src: (0,paths/* getPublicPath */.A)("/images/stateSector/2025/hero.png"),
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIntro, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroTitle, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2025",
                            i18nKey: "mantechcar25.hero.intro-title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroText, {
                        ref: clampableText,
                        className: "".concat(showAllText ? "display-full-text" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2025",
                            i18nKey: "mantechcar25.hero.intro"
                        })
                    }),
                    displayReadMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledReadMoreButton, {
                        type: "button",
                        onClick: function() {
                            return setShowAllText(!showAllText);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: !showAllText ? pro_solid_svg_icons/* faPlusCircle */.KtF : pro_solid_svg_icons/* faMinusCircle */.uMC
                            }),
                            !showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("mantechcar25.hero.read-more")
                            }),
                            showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("mantechcar25.hero.read-less")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Intro_styled_StyledData, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Intro_styled_StyledDataTitle, {
                        children: t("mantechcar25.data.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataList, {
                        children: introData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataValue, {
                                        children: item.value
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataContent, {
                                        children: item.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var intro_Intro = (Intro);

// EXTERNAL MODULE: ./components/shared/accordion/Accordion.tsx
var Accordion = __webpack_require__(71652);
;// CONCATENATED MODULE: ./data/mantechcar25/methodology-experience.json
var methodology_experience_namespaceObject = JSON.parse('[{"exp":"<2","share":19.97,"fill":"#08306B"},{"exp":"2-5","share":20.75,"fill":"#08519C"},{"exp":"5-10","share":14.22,"fill":"#2171B5"},{"exp":"10+","share":10.59,"fill":"#4292C6"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/charts/MethodologyExperience.tsx




var MethodologyExperience = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 180,
                width: "99%",
                minWidth: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: methodology_experience_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "exp",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyExperience = (MethodologyExperience);

;// CONCATENATED MODULE: ./data/mantechcar25/methodology-gender.json
var methodology_gender_namespaceObject = JSON.parse('[{"name":"f","value":19320,"fill":"#6A3D99"},{"name":"m","value":88288,"fill":"#1E77B3"},{"name":"u","value":2366,"fill":"#F2F2F2"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/charts/MethodologyGender.tsx






var MethodologyGender = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology gender",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 400,
                height: 400,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                        layout: "vertical",
                        align: "right",
                        verticalAlign: "top",
                        iconType: "square",
                        width: 120
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        labelStyle: {
                            display: "none"
                        },
                        separator: ": ",
                        formatter: function(value) {
                            return value.toLocaleString(locale);
                        },
                        wrapperClassName: "tooltip-y"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: methodology_gender_namespaceObject,
                        dataKey: "value",
                        cx: "50%",
                        cy: "28%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                name: t("mantechcar25.methodology.gender.females")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                name: t("mantechcar25.methodology.gender.males")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                name: t("mantechcar25.methodology.gender.undefined")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyGender = (MethodologyGender);

;// CONCATENATED MODULE: ./data/mantechcar25/methodology-roles.json
var methodology_roles_namespaceObject = JSON.parse('[{"role":"Backend Developer","share":29.6,"fill":"#08306B"},{"role":"Frontend Developer","share":23.1,"fill":"#08306B"},{"role":"Full-Stack Developer","share":22.94,"fill":"#08519C"},{"role":"Software Architect","share":5.59,"fill":"#08519C"},{"role":"Project Manager & Delivery Manager","share":5.41,"fill":"#2171B5"},{"role":"Mobile Developer","share":5.29,"fill":"#2171B5"},{"role":"DevOps & Infrastructure & SRE","share":5,"fill":"#4292C6"},{"role":"Data Scientist","share":4.99,"fill":"#4292C6"},{"role":"Engineering Management","share":4.37,"fill":"#6BAED6"},{"role":"Data Engineer","share":4.31,"fill":"#6BAED6"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/charts/MethodologyRoles.tsx




var MethodologyRoles = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "methodology",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 330,
                width: "99%",
                minWidth: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: methodology_roles_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "role",
                            tickLine: false,
                            width: 160
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "transparent"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "share",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MethodologyRoles = (MethodologyRoles);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/Methodology.constants.tsx






var genderAccordion = function(t) {
    return [
        {
            summary: t("mantechcar25.methodology.gender.api-title"),
            details: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "developer-career-report-2025",
                i18nKey: "mantechcar25.methodology.gender.api-content"
            })
        },
        {
            summary: t("mantechcar25.methodology.gender.question-title"),
            details: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                ns: "developer-career-report-2025",
                i18nKey: "mantechcar25.methodology.gender.question-content"
            })
        }
    ];
};
var METHODOLOGYSECTIONS = function(t) {
    return [
        {
            title: t("mantechcar25.methodology.experience.title"),
            desc: "mantechcar25.methodology.experience.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyExperience, {})
        },
        {
            title: t("mantechcar25.methodology.roles.title"),
            desc: "mantechcar25.methodology.roles.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyRoles, {})
        },
        {
            title: t("mantechcar25.methodology.gender.title"),
            desc: "mantechcar25.methodology.gender.desc",
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MethodologyGender, {}),
            accordion: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                items: genderAccordion(t)
            })
        }
    ];
};

// EXTERNAL MODULE: ./components/shared/accordion/Accordion.styled.tsx
var Accordion_styled = __webpack_require__(28619);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/Methodology.styled.tsx

function Methodology_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Methodology_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: left;\n  padding: ",
        " ",
        ";\n"
    ]);
    Methodology_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.6;\n"
    ]);
    Methodology_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    Methodology_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 22rem;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  flex-grow: 1;\n\n  p {\n    margin-top: 0;\n    line-height: 1.5;\n  }\n\n  ",
        " {\n    border: 1px solid ",
        ";\n    border-radius: ",
        ";\n  }\n\n  ",
        ":first-child {\n    ",
        " {\n      border-top: 0;\n    }\n  }\n\n  ",
        " {\n    padding: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    font-size: ",
        ";\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n  letter-spacing: 0.35em;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    Methodology_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n  padding-top: ",
        ";\n\n  a {\n    font-weight: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-0"
})(Methodology_styled_templateObject(), (0,theme/* color */.$_)("white"));
var Methodology_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-1"
})(Methodology_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var Methodology_styled_StyledDesc = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef50c3ca-2"
})(Methodology_styled_templateObject2(), (0,theme/* fontSize */.JB)("lg"));
var Methodology_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-3"
})(Methodology_styled_templateObject3(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* screen */.sp)("md"));
var StyledSectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-4"
})(Methodology_styled_templateObject4(), (0,theme/* spacing */.W0)("lg"), Accordion_styled/* StyledAccordion */.sB, (0,theme/* color */.$_)("midnight_200"), (0,theme/* radius */.q0)("md"), Accordion_styled/* StyledAccordionItem */.wW, Accordion_styled/* StyledSummary */.WQ, Accordion_styled/* StyledTrigger */.tr, (0,theme/* spacing */.W0)("md"), Accordion_styled/* StyledTitle */.X0, (0,theme/* fontSize */.JB)("md"), Accordion_styled/* StyledContent */.Hz, (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledSectionTitle = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-ef50c3ca-5"
})(Methodology_styled_templateObject5(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledSectionChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef50c3ca-6"
})(Methodology_styled_templateObject6());
var StyledThanks = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-ef50c3ca-7"
})(Methodology_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/MethodologySection.tsx



var MethodologySection = function(param) {
    var title = param.title, desc = param.desc, chart = param.chart, accordion = param.accordion;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSectionContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            ns: "developer-career-report-2025",
                            i18nKey: desc
                        })
                    }),
                    accordion && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: accordion
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSectionChart, {
                children: chart
            })
        ]
    });
};
/* harmony default export */ var methodology_MethodologySection = (MethodologySection);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/methodology/Methodology.tsx







var Methodology = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var sections = METHODOLOGYSECTIONS(t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                    editorial: true,
                    alignLeft: true,
                    as: "h5",
                    children: t("mantechcar25.methodology.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Methodology_styled_StyledDesc, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                        ns: "developer-career-report-2025",
                        i18nKey: "mantechcar25.methodology.desc"
                    })
                }),
                sections.map(function(section, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_MethodologySection, {
                        title: section.title,
                        desc: section.desc,
                        chart: section.chart,
                        accordion: section.accordion
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var methodology_Methodology = (Methodology);

;// CONCATENATED MODULE: ./data/mantechcar25/roles-distribution.json
var roles_distribution_namespaceObject = JSON.parse('[{"name":"Backend Developer","value":29.598316242,"fill":"#084081"},{"name":"Frontend Developer","value":23.1015180691,"fill":"#0868AC"},{"name":"Full-Stack Developer","value":22.9429940442,"fill":"#2B8CBE"},{"name":"Software Architect","value":5.5904348215,"fill":"#50B4D3"},{"name":"Project Manager & Delivery Manager","value":5.4077291657,"fill":"#7BCCC4"},{"name":"Mobile Developer","value":5.2939859388,"fill":"#A8DDB5"},{"name":"Marketing","value":5.0181362232,"fill":"#CDEBC6"},{"name":"Operaciones y Estrategia","value":5.0047019838,"fill":"#E0F3DB"},{"name":"DevOps & Infrastructure & SRE","value":4.9957458242,"fill":"#F7FCF0"},{"name":"Data Scientist","value":4.9948502082,"fill":"green"},{"name":"Software Engineering","value":4.64197752,"fill":"#084081"},{"name":"Engineering Management","value":4.3697102682,"fill":"#0868AC"},{"name":"Data Engineer","value":4.3132864628,"fill":"#2B8CBE"},{"name":"Data Analyst & BI","value":4.2049169316,"fill":"#50B4D3"},{"name":"Tech Lead","value":3.9102592808,"fill":"#7BCCC4"},{"name":"Ventas y Gestión de Cuentas","value":3.5197707223,"fill":"#A8DDB5"},{"name":"Product Design (UI/UX)","value":3.2179481438,"fill":"#CDEBC6"},{"name":"QA & Testing","value":3.0280775603,"fill":"#E0F3DB"},{"name":"Diseño","value":2.6868478796,"fill":"#F7FCF0"},{"name":"Otros (Ingeniería)","value":2.655501321,"fill":"green"},{"name":"Producto","value":2.6053468273,"fill":"#084081"},{"name":"VP of Engineering","value":2.3250190318,"fill":"#0868AC"},{"name":"Product Manager","value":2.0840983386,"fill":"#2B8CBE"},{"name":"Finanzas, Legal y Compliance","value":1.7688415208,"fill":"#50B4D3"},{"name":"Machine Learning Engineer","value":1.4535847029,"fill":"#7BCCC4"},{"name":"SysAdmin","value":1.4123863687,"fill":"#A8DDB5"},{"name":"People, RR.HH, Recruitment","value":1.271774663,"fill":"#CDEBC6"}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/Treemap.js + 1 modules
var Treemap = __webpack_require__(65701);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/RolesDistribution.tsx




var RolesDistribution = function() {
    var COLORS = [
        "#08306B",
        "#081D58",
        "#0868AC",
        "#08519C",
        "#253494",
        "#2B8CBE",
        "#2171B5",
        "#50B4D3",
        "#4292C6",
        "#1D91C0",
        "#7BCCC4",
        "#41B6C4",
        "#6BAED6",
        "#A8DDB5"
    ];
    var CustomContent = function(param) {
        var root = param.root, x = param.x, y = param.y, width = param.width, height = param.height, index = param.index, colors = param.colors, name = param.name;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    style: {
                        fill: colors[Math.floor(index / root.children.length * 14)],
                        stroke: "#fff",
                        strokeWidth: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("foreignObject", {
                    x: x + 5,
                    y: y,
                    width: width,
                    height: height,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            color: "#fff",
                            fontSize: "12px",
                            fontWeight: 500,
                            marginRight: "5px",
                            marginTop: "10px",
                            lineHeight: 1.2,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        children: name
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "treemap",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 450,
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Treemap/* Treemap */.W, {
                    data: roles_distribution_namespaceObject,
                    aspectRatio: 16 / 9,
                    nameKey: "name",
                    stroke: "#fff",
                    fill: "#FFF8DF",
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomContent, {
                        colors: COLORS
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "#ebe8df"
                        },
                        formatter: function(value, name) {
                            return [
                                value.toFixed(1) + "%",
                                name
                            ];
                        }
                    })
                })
            })
        })
    });
};
/* harmony default export */ var charts_RolesDistribution = (RolesDistribution);

;// CONCATENATED MODULE: ./data/mantechcar25/soft-skills.json
var soft_skills_namespaceObject = JSON.parse('[{"skill":{"en":"Teamwork","es":"Trabajo en equipo"},"offers":59.48905109489051,"users":32.56309813060941},{"skill":{"en":"Proactivity","es":"Proactividad"},"offers":42.408759124087595,"users":19.160013884068032},{"skill":{"en":"Continuous Learning","es":"Aprendizaje Continuo"},"offers":38.24817518248175,"users":44.73645063717955},{"skill":{"en":"Self-management","es":"Capacidad de autogestión"},"offers":32.189781021897815,"users":12.302275995438091},{"skill":{"en":"Attention to detail","es":"Atención al detalle"},"offers":30.364963503649633,"users":16.700550404125554},{"skill":{"en":"Adaptability to change","es":"Adaptabilidad al cambio"},"offers":29.56204379562044,"users":32.78623493826549},{"skill":{"en":"Verbal communication","es":"Comunicación verbal"},"offers":22.335766423357665,"users":4.313978281350721},{"skill":{"en":"Analytical thinking","es":"Pensamiento analítico"},"offers":17.810218978102192,"users":20.424455794119105},{"skill":{"en":"Autonomy in learning","es":"Autonomía en el aprendizaje"},"offers":15.839416058394159,"users":19.631080478008627},{"skill":{"en":"Leadership","es":"Liderazgo"},"offers":12.481751824817518,"users":11.122130212723755},{"skill":{"en":"Written communication","es":"Comunicación escrita"},"offers":11.824817518248175,"users":2.0280656518074083},{"skill":{"en":"Ability to give feedback","es":"Capacidad de dar feedback"},"offers":9.854014598540147,"users":3.6544850498338874},{"skill":{"en":"Team management","es":"Gestión de equipo"},"offers":7.518248175182482,"users":7.527148311598156},{"skill":{"en":"Ability to receive feedback","es":"Capacidad de recibir feedback"},"offers":6.4963503649635035,"users":5.900728913571676},{"skill":{"en":"Strategic vision","es":"Visión estratégica"},"offers":6.204379562043796,"users":6.485843209203154},{"skill":{"en":"Listening skills","es":"Capacidad de escucha"},"offers":5.839416058394161,"users":7.348638865473298},{"skill":{"en":"Creative thinking","es":"Pensamiento creativo"},"offers":3.8686131386861313,"users":9.71884762235335},{"skill":{"en":"Critical thinking","es":"Visión crítica"},"offers":3.2116788321167884,"users":4.651162790697675},{"skill":{"en":"Negotiation skills","es":"Habilidades de negociación"},"offers":2.9927007299270074,"users":1.1801457827143353},{"skill":{"en":"Mentorship ability","es":"Capacidad de mentorización"},"offers":2.9197080291970803,"users":5.583378787127486},{"skill":{"en":"Emotional intelligence","es":"Inteligencia emocional"},"offers":2.7737226277372264,"users":6.827986314275797},{"skill":{"en":"Tolerance to uncertainty","es":"Tolerancia a la incertidumbre"},"offers":1.897810218978102,"users":1.6363365894778599},{"skill":{"en":"Presentation skills","es":"Capacidad de presentación"},"offers":1.7518248175182483,"users":1.710715525363217},{"skill":{"en":"Intercultural communication","es":"Comunicación intercultural"},"offers":1.532846715328467,"users":1.6660881638320029},{"skill":{"en":"Abstract thinking","es":"Capacidad de abstracción"},"offers":1.4598540145985401,"users":5.900728913571676},{"skill":{"en":"Resilience to frustration","es":"Resistencia a la frustración"},"offers":0.7299270072992701,"users":3.664402241285268}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/SoftSkillsCommunityVsOffered.tsx






var SoftSkillsCommunityVsOffered = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "skills",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 650,
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: soft_skills_namespaceObject.slice(0, 15),
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: function(data) {
                                return data.skill[locale || "en"];
                            },
                            tickLine: false,
                            width: 200
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: ": ",
                            formatter: function(value, name) {
                                return [
                                    value.toFixed(1) + "%",
                                    name
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Legend/* Legend */.D, {
                            layout: "horizontal",
                            iconType: "square",
                            wrapperStyle: {
                                bottom: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "offers",
                            name: t("mantechcar25.talent.competences.companies"),
                            fill: "#7EAFD3",
                            barSize: 8,
                            radius: 5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "users",
                            name: t("mantechcar25.talent.competences.community"),
                            fill: "#8DD3C7",
                            barSize: 8,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SoftSkillsCommunityVsOffered = (SoftSkillsCommunityVsOffered);

;// CONCATENATED MODULE: ./data/mantechcar25/talent-by-technology-backend.json
var talent_by_technology_backend_namespaceObject = JSON.parse('[{"tech":"Python","position":1,"shareValue":23.21,"experienceTier1":33.68,"experienceTier2":32.05,"experienceTier3":20.49,"experienceTier4":13.78},{"tech":"Java","position":2,"shareValue":22.38,"experienceTier1":30.41,"experienceTier2":30.2,"experienceTier3":21.2,"experienceTier4":18.19},{"tech":"NodeJS","position":3,"shareValue":18.05,"experienceTier1":33.8,"experienceTier2":34.39,"experienceTier3":20.07,"experienceTier4":11.74},{"tech":"PHP","position":4,"shareValue":12.91,"experienceTier1":25.58,"experienceTier2":28.76,"experienceTier3":23.44,"experienceTier4":22.22},{"tech":"C#","position":5,"shareValue":8.73,"experienceTier1":25.88,"experienceTier2":31.89,"experienceTier3":23.26,"experienceTier4":18.96},{"tech":"C++","position":6,"shareValue":5.16,"experienceTier1":28.61,"experienceTier2":30.73,"experienceTier3":20.98,"experienceTier4":19.68},{"tech":"Go","position":7,"shareValue":2.24,"experienceTier1":21.5,"experienceTier2":34.62,"experienceTier3":27.29,"experienceTier4":16.59},{"tech":"Ruby","position":8,"shareValue":1.45,"experienceTier1":22.21,"experienceTier2":31.61,"experienceTier3":23.61,"experienceTier4":22.58},{"tech":"Rust","position":9,"shareValue":0.52,"experienceTier1":20.42,"experienceTier2":32.95,"experienceTier3":28.9,"experienceTier4":17.73}]');
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/LabelList.js
var LabelList = __webpack_require__(96621);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/TalentByTech.styled.tsx

function TalentByTech_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  overflow-x: auto;\n"
    ]);
    TalentByTech_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TalentByTech_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: auto auto repeat(2, minmax(0, 1fr));\n  margin-bottom: ",
        ";\n  min-width: 750px;\n"
    ]);
    TalentByTech_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TalentByTech_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border-bottom: 1px solid ",
        ";\n  font-size: ",
        ";\n\n  &.hasChart {\n    padding: ",
        " ",
        ";\n  }\n\n  .recharts-label {\n    font-size: ",
        ";\n  }\n"
    ]);
    TalentByTech_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TalentByTech_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  border-bottom: 1px solid ",
        ";\n  border-top: 1px solid ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    TalentByTech_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledTableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1d027f7-0"
})(TalentByTech_styled_templateObject());
var TalentByTech_styled_StyledTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1d027f7-1"
})(TalentByTech_styled_templateObject1(), (0,theme/* spacing */.W0)("md"));
var StyledCell = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1d027f7-2"
})(TalentByTech_styled_templateObject2(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xs"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1d027f7-3"
})(TalentByTech_styled_templateObject3(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/TalentByTechBackend.tsx







var TalentByTechBackend = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_backend_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 0,
                                                right: 30
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechBackend = (TalentByTechBackend);

;// CONCATENATED MODULE: ./data/mantechcar25/talent-by-technology-data.json
var talent_by_technology_data_namespaceObject = JSON.parse('[{"tech":"Pandas","position":1,"shareValue":2.97,"experienceTier1":43.75,"experienceTier2":32.45,"experienceTier3":16.04,"experienceTier4":7.75},{"tech":"R","position":2,"shareValue":2.14,"experienceTier1":36.22,"experienceTier2":33.42,"experienceTier3":18.94,"experienceTier4":11.42},{"tech":"Spark","position":3,"shareValue":1.47,"experienceTier1":28.15,"experienceTier2":35.64,"experienceTier3":23.38,"experienceTier4":12.83},{"tech":"Scala","position":4,"shareValue":0.94,"experienceTier1":20.48,"experienceTier2":33.61,"experienceTier3":26.37,"experienceTier4":19.54},{"tech":"Hadoop","position":5,"shareValue":0.65,"experienceTier1":28.21,"experienceTier2":30.11,"experienceTier3":21.87,"experienceTier4":19.81}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/TalentByTechData.tsx







var TalentByTechData = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_data_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 0,
                                                right: 24
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechData = (TalentByTechData);

;// CONCATENATED MODULE: ./data/mantechcar25/talent-by-technology-frontend.json
var talent_by_technology_frontend_namespaceObject = JSON.parse('[{"tech":"React","position":1,"shareValue":21.78,"experienceTier1":37.66,"experienceTier2":34.43,"experienceTier3":18.57,"experienceTier4":9.33},{"tech":"Angular2+","position":2,"shareValue":9.32,"experienceTier1":25.36,"experienceTier2":35.85,"experienceTier3":24.82,"experienceTier4":13.98},{"tech":"Vue","position":3,"shareValue":6.98,"experienceTier1":27.05,"experienceTier2":36.57,"experienceTier3":23.34,"experienceTier4":13.03}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/TalentByTechFrontend.tsx







var TalentByTechFrontend = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_frontend_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 0,
                                                right: 24
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechFrontend = (TalentByTechFrontend);

;// CONCATENATED MODULE: ./data/mantechcar25/talent-by-technology-infra_sistemas.json
var talent_by_technology_infra_sistemas_namespaceObject = JSON.parse('[{"tech":"AWS","position":1,"shareValue":11.18,"experienceTier1":19.74,"experienceTier2":32.4,"experienceTier3":26.41,"experienceTier4":21.46},{"tech":"Azure","position":2,"shareValue":5.6,"experienceTier1":17.77,"experienceTier2":31.36,"experienceTier3":26.81,"experienceTier4":24.06},{"tech":"Kubernetes","position":3,"shareValue":5.09,"experienceTier1":15.49,"experienceTier2":30.14,"experienceTier3":28.53,"experienceTier4":25.84},{"tech":"Google Cloud","position":4,"shareValue":3.6,"experienceTier1":18.48,"experienceTier2":30.41,"experienceTier3":27.5,"experienceTier4":23.6},{"tech":"Bash","position":5,"shareValue":3.1,"experienceTier1":23.12,"experienceTier2":30.98,"experienceTier3":24.04,"experienceTier4":21.87},{"tech":"Terraform","position":6,"shareValue":2.3,"experienceTier1":17.51,"experienceTier2":28.09,"experienceTier3":30.62,"experienceTier4":23.78},{"tech":"Ansible","position":7,"shareValue":1.08,"experienceTier1":7.84,"experienceTier2":23.08,"experienceTier3":26.79,"experienceTier4":42.29},{"tech":"PowerShell","position":8,"shareValue":0.48,"experienceTier1":15.81,"experienceTier2":25.89,"experienceTier3":25.69,"experienceTier4":32.61},{"tech":"Shell","position":9,"shareValue":0.25,"experienceTier1":14.83,"experienceTier2":23.19,"experienceTier3":23.95,"experienceTier4":38.02},{"tech":"Perl","position":10,"shareValue":0.21,"experienceTier1":6.22,"experienceTier2":22.67,"experienceTier3":18.22,"experienceTier4":52.89}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/TalentByTechInfra.tsx







var TalentByTechInfra = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_infra_sistemas_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 0,
                                                right: 24
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechInfra = (TalentByTechInfra);

;// CONCATENATED MODULE: ./data/mantechcar25/talent-by-technology-mobile.json
var talent_by_technology_mobile_namespaceObject = JSON.parse('[{"tech":"React Native","position":1,"shareValue":3.86,"experienceTier1":31.43,"experienceTier2":39.05,"experienceTier3":20.58,"experienceTier4":8.94},{"tech":"Kotlin","position":2,"shareValue":3.18,"experienceTier1":27.86,"experienceTier2":31.47,"experienceTier3":24.95,"experienceTier4":15.72},{"tech":"Flutter","position":3,"shareValue":1.89,"experienceTier1":32.24,"experienceTier2":36.02,"experienceTier3":19.81,"experienceTier4":11.93},{"tech":"Swift","position":4,"shareValue":1.82,"experienceTier1":22.07,"experienceTier2":33.68,"experienceTier3":29.03,"experienceTier4":15.22},{"tech":"Ionic","position":5,"shareValue":1.28,"experienceTier1":19.04,"experienceTier2":33.85,"experienceTier3":27.99,"experienceTier4":19.12},{"tech":"Xamarin","position":6,"shareValue":0.33,"experienceTier1":15.48,"experienceTier2":29.76,"experienceTier3":24.11,"experienceTier4":30.65}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/TalentByTechMobile.tsx







var TalentByTechMobile = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TalentByTech_styled_StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.order")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.technology")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.talent-share")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                    children: t("mantechcar25.talent.talent-per-tech.years-experience")
                }),
                talent_by_technology_mobile_namespaceObject.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.position
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                children: item.tech
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "99%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            margin: {
                                                left: 0,
                                                right: 24
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        25
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "shareValue",
                                                    fill: "#9dcac2",
                                                    barSize: 8,
                                                    radius: 12,
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function(shareValue) {
                                                            return "".concat(shareValue, "%");
                                                        },
                                                        position: "right"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCell, {
                                className: "hasChart",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                                        height: 50,
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                                            data: [
                                                item
                                            ],
                                            layout: "vertical",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                                                    type: "number",
                                                    domain: [
                                                        0,
                                                        100
                                                    ],
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                                                    type: "category",
                                                    dataKey: "tech",
                                                    hide: true
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier1",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#DEEBF7",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "0-2";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier2",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#6BAED6",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "2-5";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier3",
                                                    stackId: "a",
                                                    barSize: 10,
                                                    radius: 5,
                                                    fill: "#2171B5",
                                                    isAnimationActive: false,
                                                    style: {
                                                        stroke: "#fff",
                                                        strokeWidth: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "5-10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                                                    dataKey: "experienceTier4",
                                                    stackId: "a",
                                                    barSize: 8,
                                                    radius: 5,
                                                    fill: "#08306B",
                                                    isAnimationActive: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                                        dataKey: "shareValue",
                                                        formatter: function() {
                                                            return "+10";
                                                        },
                                                        position: "bottom"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ var charts_TalentByTechMobile = (TalentByTechMobile);

;// CONCATENATED MODULE: ./data/mantechcar25/experience-by-tech-framework.json
var experience_by_tech_framework_namespaceObject = JSON.parse('[{"tech":"Express","tier1":42.47831474597274,"tier2":31.945477075588602,"tier3":17.026022304832715,"tier4":8.550185873605948},{"tech":"Bootstrap","tier1":37.8736122971819,"tier2":29.461998292058073,"tier3":18.381725021349276,"tier4":14.28266438941076},{"tech":"React","tier1":37.66053631973698,"tier2":34.43439843830268,"tier3":18.570841467173533,"tier4":9.334223774786809},{"tech":"Spring Boot","tier1":30.040172593364083,"tier2":32.71834548430293,"tier3":21.202202053265886,"tier4":16.0392798690671},{"tech":"Laravel","tier1":27.518216888126872,"tier2":35.55507929704243,"tier3":22.953279039862835,"tier4":13.973424774967851},{"tech":"Vue","tier1":27.054491899852724,"tier2":36.56848306332842,"tier3":23.343151693667156,"tier4":13.033873343151695},{"tech":"Angular2+","tier1":25.361411496869664,"tier2":35.8451906659078,"tier3":24.81502561183836,"tier4":13.978372225384177},{"tech":"Spring","tier1":23.499806426635693,"tier2":30.60394889663182,"tier3":24.041811846689896,"tier4":21.854432830042587},{"tech":".NET","tier1":20.579093734663832,"tier2":31.228529363651237,"tier3":24.6360215933257,"tier4":23.556355308359233},{"tech":"jQuery","tier1":17.95125817317218,"tier2":28.31384981176937,"tier3":26.64949474935605,"tier4":27.085397265702397}]');
;// CONCATENATED MODULE: ./data/mantechcar25/experience-by-tech-language.json
var experience_by_tech_language_namespaceObject = JSON.parse('[{"tech":"CSS","tier1":39.08994815523229,"tier2":30.583379473498766,"tier3":17.652388382745258,"tier4":12.674283988523683},{"tech":"HTML","tier1":38.626972201352366,"tier2":30.41885800150263,"tier3":17.984598046581517,"tier4":12.969571750563485},{"tech":"JavaScript","tier1":34.48763917720324,"tier2":32.11297729131283,"tier3":19.46908221677046,"tier4":13.930301314713468},{"tech":"Python","tier1":33.67875647668394,"tier2":32.048987282147905,"tier3":20.48987282147904,"tier4":13.78238341968912},{"tech":"TypeScript","tier1":30.786876129570416,"tier2":37.11942165994717,"tier3":22.271652995968303,"tier4":9.822049214514111},{"tech":"Java","tier1":30.414463746223564,"tier2":30.19731873111782,"tier3":21.1952416918429,"tier4":18.192975830815712},{"tech":"C++","tier1":28.606760098928273,"tier2":30.729596042868916,"tier3":20.981038746908492,"tier4":19.68260511129431},{"tech":"SQL","tier1":27.15730578868087,"tier2":30.772541424574996,"tier3":22.501972598809267,"tier4":19.56818018793487},{"tech":"C#","tier1":25.884455032757593,"tier2":31.888028588445504,"tier3":23.263847528290647,"tier4":18.963668850506256},{"tech":"PHP","tier1":25.5800883179446,"tier2":28.759534323564832,"tier3":23.44439983942192,"tier4":22.215977519068648}]');
;// CONCATENATED MODULE: ./data/mantechcar25/experience-by-tech-other.json
var experience_by_tech_other_namespaceObject = JSON.parse('[{"tech":"NodeJS","tier1":33.80222422602945,"tier2":34.39134355275023,"tier3":20.066125638713554,"tier4":11.740306582506763},{"tech":"MongoDB","tier1":31.03817686014803,"tier2":32.13868328788469,"tier3":20.4811063498247,"tier4":16.342033502142577},{"tech":"MySQL","tier1":30.0317764854008,"tier2":29.57611367587985,"tier3":20.582768751124167,"tier4":19.809341087595183},{"tech":"Git","tier1":27.295412844036697,"tier2":31.889908256880734,"tier3":22.788990825688074,"tier4":18.025688073394495},{"tech":"PostgreSQL","tier1":26.474622770919066,"tier2":32.27814709296191,"tier3":22.633744855967077,"tier4":18.61348528015195},{"tech":"Linux","tier1":22.808743169398905,"tier2":29.60655737704918,"tier3":23.147540983606557,"tier4":24.437158469945356},{"tech":"SQLServer","tier1":22.377968337730874,"tier2":30.343007915567284,"tier3":22.54287598944591,"tier4":24.736147757255935},{"tech":"Docker","tier1":21.151988108509848,"tier2":33.31103678929766,"tier3":25.143069490895577,"tier4":20.393905611296915},{"tech":"AWS","tier1":19.737883718884685,"tier2":32.395109508312075,"tier3":26.40513677544199,"tier4":21.461869997361248},{"tech":"Jira","tier1":17.897762779652542,"tier2":31.471066116735408,"tier3":27.459067616547934,"tier4":23.172103487064117}]');
;// CONCATENATED MODULE: ./data/mantechcar25/least-wanted-techs-by-framework.json
var least_wanted_techs_by_framework_namespaceObject = JSON.parse('[{"name":".NET","value":16.6755517646,"fill":"#08306B"},{"name":"AngularJS","value":6.8450794328,"fill":"#08306B"},{"name":"React","value":3.8383622988,"fill":"#08519C"},{"name":"Angular2+","value":3.5504851263,"fill":"#08519C"},{"name":"jQuery","value":2.2390446743,"fill":"#4292C6"},{"name":".Net Core","value":1.9191811494,"fill":"#4292C6"},{"name":"Vue","value":1.524682802,"fill":"#6BAED6"},{"name":"React Native","value":1.0981981021,"fill":"#6BAED6"},{"name":"Angular Universal","value":0.9276042222,"fill":"#9ECAE1"},{"name":"Ruby on Rails","value":0.9276042222,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/LeastWantedTechsByFrameworks.tsx




var LeastWantedTechsByFrameworks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: least_wanted_techs_by_framework_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LeastWantedTechsByFrameworks = (LeastWantedTechsByFrameworks);

;// CONCATENATED MODULE: ./data/mantechcar25/least-wanted-techs-by-language.json
var least_wanted_techs_by_language_namespaceObject = JSON.parse('[{"name":"Java","value":24.3416142446,"fill":"#08306B"},{"name":"PHP","value":20.140739951,"fill":"#08306B"},{"name":"C++","value":6.034758503,"fill":"#08519C"},{"name":"Python","value":5.6189359207,"fill":"#08519C"},{"name":"C#","value":5.2350996908,"fill":"#4292C6"},{"name":"C","value":4.4780893485,"fill":"#4292C6"},{"name":"JavaScript","value":4.3927924086,"fill":"#6BAED6"},{"name":"Cobol","value":4.2008742936,"fill":"#6BAED6"},{"name":"CSS","value":2.8681096066,"fill":"#9ECAE1"},{"name":"HTML","value":2.1004371468,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/LeastWantedTechsByLanguage.tsx




var LeastWantedTechsByLanguage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: least_wanted_techs_by_language_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LeastWantedTechsByLanguage = (LeastWantedTechsByLanguage);

;// CONCATENATED MODULE: ./data/mantechcar25/least-wanted-techs-by-other.json
var least_wanted_techs_by_other_namespaceObject = JSON.parse('[{"name":"WordPress","value":3.6251199488,"fill":"#08306B"},{"name":"Windows","value":2.3883143192,"fill":"#08306B"},{"name":"SAP","value":1.1195223371,"fill":"#08519C"},{"name":"NodeJS","value":0.9595905747,"fill":"#08519C"},{"name":"Android","value":0.8956178697,"fill":"#4292C6"},{"name":"Autodesk 3D Studio Max","value":0.7676724598,"fill":"#4292C6"},{"name":"Azure","value":0.6823755198,"fill":"#6BAED6"},{"name":"Oracle","value":0.6823755198,"fill":"#6BAED6"},{"name":"Adobe Photoshop","value":0.6184028148,"fill":"#9ECAE1"},{"name":"JSP","value":0.6077406973,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/LeastWantedTechsByOther.tsx




var LeastWantedTechsByOther = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: least_wanted_techs_by_other_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_LeastWantedTechsByOther = (LeastWantedTechsByOther);

;// CONCATENATED MODULE: ./data/mantechcar25/most-used-techs-by-framework.json
var most_used_techs_by_framework_namespaceObject = JSON.parse('[{"name":"React","value":21.7813801442,"fill":"#08306B"},{"name":"Angular2+","value":9.3215709104,"fill":"#08306B"},{"name":"Vue","value":6.9840132551,"fill":"#08519C"},{"name":"Spring Boot","value":6.8819130357,"fill":"#08519C"},{"name":".NET","value":6.070484976,"fill":"#4292C6"},{"name":"jQuery","value":5.1730777842,"fill":"#4292C6"},{"name":"Spring","value":5.1703909364,"fill":"#6BAED6"},{"name":"Laravel","value":4.7799023779,"fill":"#6BAED6"},{"name":"Bootstrap","value":4.6088397295,"fill":"#9ECAE1"},{"name":"Express","value":4.1216246474,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/MostUsedTechsByFrameworks.tsx




var MostUsedTechsByFrameworks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: most_used_techs_by_framework_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostUsedTechsByFrameworks = (MostUsedTechsByFrameworks);

;// CONCATENATED MODULE: ./data/mantechcar25/most-used-techs-by-language.json
var most_used_techs_by_language_namespaceObject = JSON.parse('[{"name":"JavaScript","value":35.0051497918,"fill":"#08306B"},{"name":"HTML","value":23.9496663831,"fill":"#08306B"},{"name":"Python","value":23.2072007523,"fill":"#08519C"},{"name":"Java","value":22.3769647575,"fill":"#08519C"},{"name":"CSS","value":22.3339751914,"fill":"#4292C6"},{"name":"TypeScript","value":15.0060454077,"fill":"#4292C6"},{"name":"SQL","value":13.6500828445,"fill":"#6BAED6"},{"name":"PHP","value":12.9058259818,"fill":"#6BAED6"},{"name":"C#","value":8.7349424567,"fill":"#9ECAE1"},{"name":"C++","value":5.1632260087,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/MostUsedTechsByLanguage.tsx




var MostUsedTechsByLanguage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: most_used_techs_by_language_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            tickFormatter: function(tick) {
                                return "".concat(tick, "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostUsedTechsByLanguage = (MostUsedTechsByLanguage);

;// CONCATENATED MODULE: ./data/mantechcar25/most-used-techs-by-other.json
var most_used_techs_by_other_namespaceObject = JSON.parse('[{"name":"NodeJS","value":18.0493484394,"fill":"#08306B"},{"name":"MySQL","value":17.6275133223,"fill":"#08306B"},{"name":"Git","value":13.2846715328,"fill":"#08519C"},{"name":"Docker","value":13.1736151538,"fill":"#08519C"},{"name":"AWS","value":11.1781827952,"fill":"#4292C6"},{"name":"MongoDB","value":10.8602391295,"fill":"#4292C6"},{"name":"PostgreSQL","value":9.6108548654,"fill":"#6BAED6"},{"name":"Linux","value":9.3663517084,"fill":"#6BAED6"},{"name":"Jira","value":7.7479736689,"fill":"#9ECAE1"},{"name":"SQLServer","value":6.4188795844,"fill":"#9ECAE1"}]');
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/charts/MostUsedTechsByOther.tsx




var MostUsedTechsByOther = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                height: 400,
                width: "99%",
                minWidth: 500,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: most_used_techs_by_other_namespaceObject,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 20
                            },
                            domain: [
                                0,
                                6
                            ],
                            tickFormatter: function(tick) {
                                return "".concat(tick.toFixed(1), "%");
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "name",
                            tickLine: false,
                            width: 120
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#ebe8df"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value.toFixed(1) + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "fill",
                            barSize: 12,
                            radius: 5
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_MostUsedTechsByOther = (MostUsedTechsByOther);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/ExperienceByRole.styled.tsx

function ExperienceByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  & > * {\n    width: 100%;\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ExperienceByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  &.experience-table {\n    max-width: ",
        ";\n  }\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ExperienceByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 4.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n  &.cell-color-8 {\n    background-color: ",
        ";\n  }\n"
    ]);
    ExperienceByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ExperienceByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c7559a6-0"
})(ExperienceByRole_styled_templateObject());
var ExperienceByRole_styled_StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-8c7559a6-1"
})(ExperienceByRole_styled_templateObject1(), (0,theme/* spacing */.W0)("sm"), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var ExperienceByRole_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c7559a6-2"
})(ExperienceByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("seq_blue_02"), (0,theme/* color */.$_)("seq_blue_03"), (0,theme/* color */.$_)("seq_blue_04"), (0,theme/* color */.$_)("seq_blue_05"), (0,theme/* color */.$_)("seq_blue_06"), (0,theme/* color */.$_)("seq_blue_07"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* color */.$_)("seq_blue_09"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/ExperienceByRole.tsx



var ExperienceByRole = function(param) {
    var data = param.data;
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 5) {
            return "cell-color-2";
        }
        if (val > 5 && val <= 9) {
            return "cell-color-3";
        }
        if (val > 9 && val <= 14) {
            return "cell-color-4";
        }
        if (val > 14 && val <= 19) {
            return "cell-color-5";
        }
        if (val > 19 && val <= 24) {
            return "cell-color-6";
        }
        if (val > 24 && val <= 29) {
            return "cell-color-7";
        }
        if (val > 29) {
            return "cell-color-8";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceByRole_styled_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledTable, {
            className: "experience-table",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "<2y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "2-5y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "5-10y"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: ">10y"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: data.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: data.tech
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier1),
                                        children: [
                                            data.tier1.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier2),
                                        children: [
                                            data.tier2.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier3),
                                        children: [
                                            data.tier3.toFixed(1),
                                            "%"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExperienceByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier4),
                                        children: [
                                            data.tier4.toFixed(1),
                                            "%"
                                        ]
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var talent_ExperienceByRole = (ExperienceByRole);

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/Talent.constants.tsx











var TALENTBYTECHOPTIONS = function(t) {
    return [
        {
            label: t("mantechcar25.talent.talent-per-tech.back"),
            value: "back"
        },
        {
            label: t("mantechcar25.talent.talent-per-tech.front"),
            value: "front"
        },
        {
            label: t("mantechcar25.talent.talent-per-tech.mobile"),
            value: "mobile"
        },
        {
            label: t("mantechcar25.talent.talent-per-tech.data"),
            value: "data"
        },
        {
            label: t("mantechcar25.talent.talent-per-tech.infra"),
            value: "infra"
        }
    ];
};
var MOSTUSEDTECHSTABS = function(t) {
    return {
        tabsName: "mostUsedTechs",
        tabs: [
            {
                id: "mostUsedTechsByLang",
                label: t("mantechcar25.talent.most-used-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByLanguage, {})
            },
            {
                id: "mostUsedTechsByFrameworks",
                label: t("mantechcar25.talent.most-used-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByFrameworks, {})
            },
            {
                id: "mostUsedTechsByOther",
                label: t("mantechcar25.talent.most-used-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_MostUsedTechsByOther, {})
            }
        ]
    };
};
var LEASTWANTEDTECHSTABS = function(t) {
    return {
        tabsName: "leastWantedTechs",
        tabs: [
            {
                id: "leastWantedTechsByLang",
                label: t("mantechcar25.talent.least-wanted-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByLanguage, {})
            },
            {
                id: "leastWantedTechsByFrameworks",
                label: t("mantechcar25.talent.least-wanted-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByFrameworks, {})
            },
            {
                id: "leastWantedTechsByOther",
                label: t("mantechcar25.talent.least-wanted-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_LeastWantedTechsByOther, {})
            }
        ]
    };
};
var EXPERIENCEBYROLETABS = function(t) {
    return {
        tabsName: "experienceByRole",
        tabs: [
            {
                id: "experienceByRoleByLang",
                label: t("mantechcar25.talent.main-techs.languages"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: experience_by_tech_language_namespaceObject
                })
            },
            {
                id: "experienceByRoleByFramework",
                label: t("mantechcar25.talent.main-techs.frameworks"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: experience_by_tech_framework_namespaceObject
                })
            },
            {
                id: "experienceByRoleByOther",
                label: t("mantechcar25.talent.main-techs.other-techs"),
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_ExperienceByRole, {
                    data: experience_by_tech_other_namespaceObject
                })
            }
        ]
    };
};

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/Talent.styled.tsx

function Talent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " ",
        "::before {\n    background-color: ",
        ";\n  }\n"
    ]);
    Talent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Talent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: flex-start;\n  min-width: 16rem;\n"
    ]);
    Talent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Talent_styled_StyledSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-55186e1e-0"
})(Talent_styled_templateObject(), StyledContainer, Typography_styled/* Heading2 */.XJ, (0,theme/* color */.$_)("sun_500"));
var StyledSelect = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-55186e1e-1"
})(Talent_styled_templateObject1());

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/components/talent/Talent.tsx


















var Talent = function() {
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    var mostUsedTechTabs = MOSTUSEDTECHSTABS(t);
    var leastWantedTechTabs = LEASTWANTEDTECHSTABS(t);
    var experienceByRoleTabs = EXPERIENCEBYROLETABS(t);
    var talentByTechOptions = TALENTBYTECHOPTIONS(t);
    var ref = (0,react.useState)("back"), currentOption = ref[0], setCurrentOption = ref[1];
    var handleOptionChange = function(param) {
        var value = param.value;
        setCurrentOption(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Talent_styled_StyledSection, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionHeroBoxes_SectionHeroBoxes, {
                boxOne: {
                    text: t("mantechcar25.talent.hero.title"),
                    color: "#7eafd3"
                },
                boxTwo: {
                    text: t("mantechcar25.talent.hero.desc"),
                    color: "#312784"
                },
                boxThree: {
                    text: t("mantechcar25.talent.hero.descExtra"),
                    color: "#2171b5",
                    textColor: "#fff"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(sectionChart_SectionChart, {
                title: t("mantechcar25.talent.talent-per-tech.title"),
                shareId: "talentpertech",
                emailSubject: t("mantechcar25.share-modal.talent-per-tech.email-subject"),
                emailMessage: t("mantechcar25.share-modal.talent-per-tech.email-text"),
                shareMessage: t("mantechcar25.share-modal.talent-per-tech.text"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwitcher, {
                        role: "tablist",
                        style: {
                            marginBottom: 8
                        },
                        children: talentByTechOptions.map(function(option, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                name: String(option.label),
                                id: String(option.value),
                                label: option.label,
                                "aria-controls": option.value + "_content",
                                "aria-selected": currentOption === option.value,
                                onChange: function() {
                                    return handleOptionChange(option);
                                },
                                checked: currentOption === option.value
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableContainer, {
                        children: [
                            currentOption === "front" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechFrontend, {}),
                            currentOption === "back" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechBackend, {}),
                            currentOption === "mobile" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechMobile, {}),
                            currentOption === "data" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechData, {}),
                            currentOption === "infra" && /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TalentByTechInfra, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.talent.roles-distribution.title"),
                desc: t("mantechcar25.talent.roles-distribution.desc"),
                descExtra: t("mantechcar25.talent.roles-distribution.descExtra"),
                shareId: "rolesdistribution",
                emailSubject: t("mantechcar25.share-modal.roles-distribution.email-subject"),
                emailMessage: t("mantechcar25.share-modal.roles-distribution.email-text"),
                shareMessage: t("mantechcar25.share-modal.roles-distribution.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_RolesDistribution, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.talent.most-used-techs.title"),
                desc: t("mantechcar25.talent.most-used-techs.desc"),
                descExtra: t("mantechcar25.talent.most-used-techs.descExtra"),
                shareId: "mostusedtechs",
                emailSubject: t("mantechcar25.share-modal.most-used-techs.email-subject"),
                emailMessage: t("mantechcar25.share-modal.most-used-techs.email-text"),
                shareMessage: t("mantechcar25.share-modal.most-used-techs.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: mostUsedTechTabs.tabsName,
                    tabs: mostUsedTechTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.talent.least-wanted-techs.title"),
                desc: t("mantechcar25.talent.least-wanted-techs.desc"),
                descExtra: t("mantechcar25.talent.least-wanted-techs.descExtra"),
                shareId: "leastwantedtechs",
                emailSubject: t("mantechcar25.share-modal.least-wanted-techs.email-subject"),
                emailMessage: t("mantechcar25.share-modal.least-wanted-techs.email-text"),
                shareMessage: t("mantechcar25.share-modal.least-wanted-techs.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: leastWantedTechTabs.tabsName,
                    tabs: leastWantedTechTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.talent.main-techs.title"),
                desc: t("mantechcar25.talent.main-techs.desc"),
                descExtra: t("mantechcar25.talent.main-techs.descExtra"),
                shareId: "experiencebyrole",
                emailSubject: t("mantechcar25.share-modal.main-techs.email-subject"),
                emailMessage: t("mantechcar25.share-modal.main-techs.email-text"),
                shareMessage: t("mantechcar25.share-modal.main-techs.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(switcher_Switcher, {
                    tabsName: experienceByRoleTabs.tabsName,
                    tabs: experienceByRoleTabs.tabs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sectionChart_SectionChart, {
                title: t("mantechcar25.talent.competences.title"),
                desc: t("mantechcar25.talent.competences.desc"),
                descExtra: t("mantechcar25.talent.competences.descExtra"),
                shareId: "competences",
                emailSubject: t("mantechcar25.share-modal.competences.email-subject"),
                emailMessage: t("mantechcar25.share-modal.competences.email-text"),
                shareMessage: t("mantechcar25.share-modal.competences.text"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SoftSkillsCommunityVsOffered, {})
            })
        ]
    });
};
/* harmony default export */ var talent_Talent = (Talent);

// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(28870);
;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/ManTechCar.styled.ts

function ManTechCar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --headingColor: #312784;\n"
    ]);
    ManTechCar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ManTechCar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: linear-gradient(\n      ",
        ",\n      ",
        "\n    ),\n    url('",
        "');\n  background-size: cover;\n  background-position: top center;\n  padding: ",
        " ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n\n  @media (min-width: ",
        ") {\n    background-image: linear-gradient(\n        ",
        ",\n        ",
        "\n      ),\n      url('",
        "');\n  }\n"
    ]);
    ManTechCar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ManTechCar_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    ManTechCar_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledPage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa95628c-0"
})(ManTechCar_styled_templateObject());
var StyledFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa95628c-1"
})(ManTechCar_styled_templateObject1(), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg-sm.webp"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* screen */.sp)("md"), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,polished_esm/* rgba */.m4)("#1F1D26", 0.75), (0,paths/* getPublicPath */.A)("/images/stateSector/2023/hero-bg.webp"));
var StyledFooterActions = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa95628c-2"
})(ManTechCar_styled_templateObject2(), (0,theme/* spacing */.W0)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/mantechcar25/ManTechCar.tsx









var ManTechCarComponent = function(param) {
    var manfreditesCount = param.manfreditesCount;
    // Render.
    // ---------------------------------------------------------------------------
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.ZP, {
        hasScrollTop: true,
        pageVariant: "light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPage, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_Intro, {
                    manfreditesCount: manfreditesCount
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(talent_Talent, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(benefits_Benefits, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_Companies, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gender_Gender, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_Methodology, {})
            ]
        })
    });
};
/* harmony default export */ var ManTechCar = (ManTechCarComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./pages/developer-career-report-2025.tsx








var ManTechCar25Page = function(param) {
    var baseUrl = param.baseUrl, manfreditesCount = param.manfreditesCount;
    var t = (0,useI18n/* useI18n */.Q)("developer-career-report-2025").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("mantechcar25.page_title"),
                url: app_urls/* APP_URLS.mantechcar25 */.uu.mantechcar25,
                desc: t("mantechcar25.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_tech_career_report_2025.png")),
                indexable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "devCareerReportLD",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n  "@context": "https://schema.org",\n  "@type": "Report",\n  "name": "'.concat(t("mantechcar25.page_title"), '",\n  "url": "https://www.getmanfred.com/developer-career-report",\n  "description": "').concat(t("mantechcar25.page_description"), '",\n  "author": {\n    "@type": "Organization",\n    "name": "Get Manfred",\n    "url": "https://www.getmanfred.com",\n    "logo": {\n      "@type": "ImageObject",\n       "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",\n    }\n  },\n  "publisher": {\n    "@type": "Organization",\n    "name": "Manfred",\n    "url": "https://www.getmanfred.com"\n  },\n  "datePublished": "2025-11-04",\n  "mainEntityOfPage": "https://www.getmanfred.com/developer-career-report",\n  "articleSection": "Carrera de Desarrolladores, Oportunidades en IT, Tendencias del Sector"\n}')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ManTechCar, {
                manfreditesCount: manfreditesCount
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var developer_career_report_2025 = (ManTechCar25Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,8746,9001,2077,3004,4926,3454,6658,625,4882,289,1352,9774,2888,179], function() { return __webpack_exec__(50814); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);